
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3wO03", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ExportIssues", () => $0f53f6582a26cbc9$export$4492cc988d338091);
$parcel$export(module.exports, "default", () => $0f53f6582a26cbc9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2NMNM = parcelRequire("2NMNM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $1tcYS = parcelRequire("1tcYS");

var $dGrdR = parcelRequire("dGrdR");

var $lzeFL = parcelRequire("lzeFL");

var $5mPDN = parcelRequire("5mPDN");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $Y0ZJB = parcelRequire("Y0ZJB");

var $WbiIJ = parcelRequire("WbiIJ");

var $9Nvh7 = parcelRequire("9Nvh7");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $9OXo1 = parcelRequire("9OXo1");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $6s1PB = parcelRequire("6s1PB");

var $8CxS5 = parcelRequire("8CxS5");

var $etArH = parcelRequire("etArH");

var $aAXPH = parcelRequire("aAXPH");


var $bOHHa = parcelRequire("bOHHa");


var $8jWt2 = parcelRequire("8jWt2");

var $6h1uG = parcelRequire("6h1uG");

var $2YYKT = parcelRequire("2YYKT");
const $0f53f6582a26cbc9$var$MaybeExportIssuesState = (0, $cSD7y.componentWithFG)('nin-export-issues-with-subscription', (0, $aAXPH.ExportIssuesState), (0, $5uXOq.Fragment));
const $0f53f6582a26cbc9$var$menuItemStyles = null;
const $0f53f6582a26cbc9$export$4492cc988d338091 = ({ showEcosystemApps: showEcosystemApps = true, browserMetricsKey: browserMetricsKey = 'unknown', jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter = false, filterName: filterName, customTriggerButton: customTriggerButton, placement: placement })=>{
    // This should be updated in the future when we're managing filter state more explicitly.
    const hasCustomFilterJqlBeenModified = (0, $9Nvh7.isCustomFilter)(filterId || '') && isModifiedFilter;
    const { fetch: fetch, exportItems: exportItems, loading: loading, error: error } = (0, $bOHHa.useFetchAllExportIssuesResources)(jql, filterId, hasCustomFilterJqlBeenModified);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [openExportIssuesInteraction] = (0, $5uXOq.useState)((0, $dGrdR.metrics).interaction({
        key: `${browserMetricsKey}.load-export-issues-dropdown.start-end.diff`
    }));
    const { locale: locale } = (0, $9OXo1.useTenantContext)();
    const { current: intlCollator } = (0, $5uXOq.useRef)(new Intl.Collator((0, $lzeFL.standardizeLocale)(locale)));
    const filteredExportItems = (0, $2YYKT.getExportItems)(exportItems) || []; // Alphabetically sort the connect apps in the export issues dropdown.
    const orderedExportItems = showEcosystemApps && (0, $2YYKT.sortConnectAppsInExportItems)(filteredExportItems, intlCollator) || filteredExportItems; /** We only want to count the number of apps added to the exports dropdown */ 
    const appCount = orderedExportItems[0, $dcaffc959cbdbdf4$export$726b5607b2c3e51c]?.length ?? 0;
    const { isOpen: isCreateDashboardGadgetModalOpen, openModal: openCreateDashboardGadgetModal, closeModal: closeCreateDashboardGadgetModal, clearAndNavigateToDashboard: clearAndNavigateToDashboard } = (0, $etArH.useCreateDashboardGadgetModalControls)();
    const dashboardGadgetModalContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const dashboardGadgetModalInstrumentedHandler = (0, $5uXOq.useCallback)((event)=>{
        if (dashboardGadgetModalContext && dashboardGadgetModalContext.tracePress) dashboardGadgetModalContext.tracePress('create-dashboard-gadget-modal', event.timeStamp);
    }, [
        dashboardGadgetModalContext
    ]); // remove onClickDropDownItem when cleanup nin-export-issues-with-subscription fg
    const onClickDropDownItem = (0, $5uXOq.useCallback)((item)=>(e)=>{
            if (item && item.id === (0, $f1cf4dfa4ee555bb$export$1e7e0a89f0a63194)) {
                dashboardGadgetModalInstrumentedHandler(e);
                openCreateDashboardGadgetModal();
            }
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dropdownItem clicked', 'export', {
                dropdownItem: item.id ?? 'app',
                dropdownItemName: item.label,
                appCount: appCount
            });
        }, [
        createAnalyticsEvent,
        appCount,
        dashboardGadgetModalInstrumentedHandler,
        openCreateDashboardGadgetModal
    ]);
    const onOpen = ()=>{
        /* We don't want to refetch if the last used jql is
     * the same as the active jql.
     */ if (!isOpen) {
            openExportIssuesInteraction.start();
            fetch(false);
        }
        setIsOpen(!isOpen);
    };
    !loading && openExportIssuesInteraction.stop();
    const exportOptionHeaderLabel = exportItems?.viewOptionHeader?.label;
    let commonInput;
    if ((0, $4R6GH.fg)('nin-export-issues-with-subscription')) // eslint-disable-next-line react-hooks/rules-of-hooks
    commonInput = (0, $5uXOq.useMemo)(()=>{
        const validFilterId = (0, $9Nvh7.isFilterId)(filterId);
        return {
            jql: jql,
            modified: isModifiedFilter,
            ...validFilterId && {
                filterId: filterId
            }
        };
    }, [
        filterId,
        isModifiedFilter,
        jql
    ]);
    const isVREnabled = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons');
    const isHierarchyEnabled = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f53f6582a26cbc9$var$MaybeExportIssuesState, {
        scope: "ExportIssuesState"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        ...!isVREnabled && (0, $4R6GH.fg)('render_export_issues_menu_to_parent') && {
            shouldRenderToParent: true
        },
        isLoading: loading,
        onOpenChange: onOpen,
        testId: "issue-navigator-action-export-issues.ui.filter-button",
        trigger: ({ triggerRef: triggerRef, ...props })=>customTriggerButton ? customTriggerButton(isOpen, {
                triggerRef: triggerRef,
                ...props
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WbiIJ.FilterButton), {
                customTriggerProps: {
                    ...props,
                    ref: triggerRef
                },
                text: formatMessage((0, $6h1uG.default).exportButtonText),
                label: "",
                isSelected: isOpen,
                vcId: "export-issues"
            }),
        shouldFlip: true,
        placement: placement || 'bottom-end',
        spacing: "compact"
    }, !error && exportOptionHeaderLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        testId: "issue-navigator-action-export-issues.ui.nso-bulk-export-info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.150",
        paddingBlock: "space.100",
        xcss: $0f53f6582a26cbc9$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtle",
        size: "small"
    }, exportOptionHeaderLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true
    }, null)) : null, !error ? orderedExportItems.map((group, index)=>showEcosystemApps || index !== (0, $dcaffc959cbdbdf4$export$726b5607b2c3e51c) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f53f6582a26cbc9$var$StyledDropDownItemGroup, {
            key: `export-item-group-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, group.map((option, dropdownItemIndex)=>(0, $4R6GH.fg)('nin-export-issues-with-subscription') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                key: index === (0, $dcaffc959cbdbdf4$export$726b5607b2c3e51c) && `export-item-app-${dropdownItemIndex}` || option.id,
                attributes: {
                    exportId: option.id,
                    exportLabel: option.label,
                    ...(0, $8CxS5.isAsyncExportItem)(option) ? {
                        exportType: option.exportType,
                        maxResults: option.maxResults,
                        fileExtension: option.fileExtension
                    } : {}
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8jWt2.ExportItem), {
                exportItem: option,
                appCount: appCount,
                commonInput: commonInput,
                onOpenCreateDashboardGadgetModal: openCreateDashboardGadgetModal
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
                key: index === (0, $dcaffc959cbdbdf4$export$726b5607b2c3e51c) && `export-item-app-${dropdownItemIndex}` || option.id,
                onClick: onClickDropDownItem(option),
                ...option.id !== (0, $f1cf4dfa4ee555bb$export$1e7e0a89f0a63194) && {
                    href: option.link ?? '#',
                    target: '_blank',
                    rel: (0, $etArH.appendExportIssuesRelPolicy)(option.rel)
                }
            }, isVREnabled && isHierarchyEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "issue-navigator-action-export-issues.ui.span",
                className: (0, $bwpsq.default)([
                    "_ca0q12x7 _n3td12x7 _19bv1b66 _u5f31b66"
                ])
            }, option.label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                "data-testid": "issue-navigator-action-export-issues.ui.span"
            }, option.label))))) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Y0ZJB.ErrorState), {
        onRetry: ()=>fetch(true),
        pageAction: "exportIssues"
    })), isCreateDashboardGadgetModalOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5mPDN.default), {
        ...(0, $etArH.getCreateDashboardGadgetModalParams)(jql, filterId, (0, $9Nvh7.isCustomFilter), hasCustomFilterJqlBeenModified),
        onCancel: closeCreateDashboardGadgetModal,
        onSuccess: clearAndNavigateToDashboard,
        filterName: filterName
    }) : null);
};
var $0f53f6582a26cbc9$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0f53f6582a26cbc9$export$4492cc988d338091;
const $0f53f6582a26cbc9$var$StyledDropDownItemGroupOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $0f53f6582a26cbc9$var$styles = (0, $8CUq3.xcss)({
    maxWidth: '14rem'
});
const $0f53f6582a26cbc9$var$dividerStyles = (0, $8CUq3.xcss)({
    borderBottomStyle: 'solid',
    borderBottomWidth: 'border.width',
    borderBottomColor: 'color.border'
});
const $0f53f6582a26cbc9$var$StyledDropDownItemGroup = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons'), ({ children: children, key: key })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        key: key,
        xcss: $0f53f6582a26cbc9$var$dividerStyles
    }, children), $0f53f6582a26cbc9$var$StyledDropDownItemGroupOld);

});
parcelRegister("5mPDN", function(module, exports) {

$parcel$export(module.exports, "default", () => $61873313b5b3f151$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $j55bS = parcelRequire("j55bS");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// We can't migrate this modal to entrypoints yet because entrypoints currently do not support rendering modals
// in legacy pages
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $61873313b5b3f151$var$LazyCreateDashboardGadgetModal = (0, $kxZPA.lazy)(()=>(parcelRequire("3aoDU")), {
    moduleId: "./src/packages/global-pages/dashboard/create-dashboard-gadget-modal/src/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61873313b5b3f151$export$2e2bcd8739ae039 = ({ onFailed: onFailed = ()=>undefined, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "AsyncCreateDashboardGadgetModal",
        packageName: "jiraDashboardCreateDashboardGadgetModal",
        fallback: "flag",
        onError: onFailed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-create-dashboard-gadget-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j55bS.default), {
            isTinted: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61873313b5b3f151$var$LazyCreateDashboardGadgetModal, props)));

});
parcelRegister("3aoDU", function(module, exports) {

let $24e56bc709a11d35$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $24e56bc709a11d35$var$load("kNFvF"),
    $24e56bc709a11d35$var$load("ffQaD"),
    $24e56bc709a11d35$var$load("kvRbA"),
    $24e56bc709a11d35$var$load("76n7a"),
    $24e56bc709a11d35$var$load("l253H"),
    $24e56bc709a11d35$var$load("f2yHP")
]).then(()=>parcelRequire('8N43S'));

});


parcelRegister("8CxS5", function(module, exports) {

$parcel$export(module.exports, "isAsyncExportItem", () => $1a6fe4863ea494f4$export$c6ef2ab3ce8646b);
$parcel$export(module.exports, "ExportIssuesDownloadError", () => $1a6fe4863ea494f4$export$6de0b57e563f6a22);

var $jJZqs = parcelRequire("jJZqs");
const $1a6fe4863ea494f4$export$c6ef2ab3ce8646b = (option)=>'exportType' in option;
class $1a6fe4863ea494f4$export$6de0b57e563f6a22 extends (0, $jJZqs.default) {
    constructor({ statusCode: statusCode, message: message, traceId: traceId, errorCode: errorCode, response: response }){
        super(statusCode, message, traceId, response);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("etArH", function(module, exports) {

$parcel$export(module.exports, "useCreateDashboardGadgetModalControls", () => $3dbc2e91f1a879fc$export$4df4404189290240);
$parcel$export(module.exports, "getCreateDashboardGadgetModalParams", () => $3dbc2e91f1a879fc$export$8b1cb81fe606b9fe);
$parcel$export(module.exports, "appendExportIssuesRelPolicy", () => $3dbc2e91f1a879fc$export$dc31a900ebcc5ee8);
$parcel$export(module.exports, "is4xxError", () => $3dbc2e91f1a879fc$export$94c4b26e937da69);
$parcel$export(module.exports, "getStatusCodeGroup", () => $3dbc2e91f1a879fc$export$d14e9b22afc87cb3);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $6jY6G = parcelRequire("6jY6G");

var $gh1hi = parcelRequire("gh1hi");

var $9VXkC = parcelRequire("9VXkC");
var $8fYaK = parcelRequire("8fYaK");
var $lVJAU = parcelRequire("lVJAU");
const $3dbc2e91f1a879fc$export$4df4404189290240 = ()=>{
    const [isOpen, setOpen] = (0, $5uXOq.useState)(false);
    const route = (0, $6jY6G.useRouteByName)('dashboard-edit');
    const { path: dashboardPath } = route ?? {};
    const [_, { clearResource: clearResource }] = (0, $8fYaK.useResourceStoreContext)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const clearAndNavigateToDashboard = (0, $5uXOq.useCallback)((dashboardId)=>{
        const url = (0, $9VXkC.generatePath)(dashboardPath, {
            dashboardId: dashboardId
        });
        route && dashboardPath && clearResource((0, $gh1hi.dashboardConfigAndWRMResource), {
            route: route,
            match: {
                params: {
                    dashboardId: dashboardId
                },
                path: dashboardPath,
                // NOTE - these are not used in dashboardConfigAndWRMResource's getKey but the types require them
                query: {},
                isExact: true,
                url: url
            },
            query: {}
        });
        setOpen(false);
        push(url);
    }, [
        clearResource,
        dashboardPath,
        push,
        route
    ]);
    const closeModal = (0, $5uXOq.useCallback)(()=>{
        setOpen(false);
    }, []);
    const openModal = (0, $5uXOq.useCallback)(()=>{
        setOpen(true);
    }, []);
    return {
        isOpen: isOpen,
        clearAndNavigateToDashboard: clearAndNavigateToDashboard,
        closeModal: closeModal,
        openModal: openModal
    };
};
const $3dbc2e91f1a879fc$export$8b1cb81fe606b9fe = (jql, filterId, isCustomFilter, hasCustomFilterJqlBeenModified)=>{
    if (jql == null && filterId == null) (0, $jcw0u.default)({
        meta: {
            id: 'getCreateDashboardGadgetModalParams',
            packageName: 'jiraIssueNavigatorActionExportIssues',
            teamName: 'empanada'
        },
        error: new Error('jql and filter are both null')
    });
    return filterId != null && isCustomFilter(filterId) && !hasCustomFilterJqlBeenModified ? {
        jql: undefined,
        filterId: filterId
    } : {
        filterId: undefined,
        jql: jql
    };
};
const $3dbc2e91f1a879fc$export$dc31a900ebcc5ee8 = (existingRelPolicy)=>{
    const EXPORT_ISSUES_REL_POLICY = [
        'noopener',
        'noreferrer',
        'nofollow'
    ];
    return existingRelPolicy.toLowerCase().split(' ').map((string)=>string.trim()).filter((string)=>string && !EXPORT_ISSUES_REL_POLICY.includes(string)).concat(EXPORT_ISSUES_REL_POLICY).join(' ');
};
const $3dbc2e91f1a879fc$export$94c4b26e937da69 = (statusCode)=>{
    return statusCode && statusCode >= 400 && statusCode < 500;
};
const $3dbc2e91f1a879fc$export$d14e9b22afc87cb3 = (statusCode)=>{
    if (statusCode) {
        if (statusCode >= 100 && statusCode < 200) return '1xx';
        if (statusCode >= 300 && statusCode < 400) return '3xx';
        if (statusCode >= 400 && statusCode < 500) return '4xx';
        if (statusCode >= 500 && statusCode < 600) return '5xx';
    }
    return 'unknown';
};

});
parcelRegister("gh1hi", function(module, exports) {

$parcel$export(module.exports, "dashboardConfigAndWRMResource", () => $ca62b878c99c7128$export$2853c0e656e89346);
$parcel$export(module.exports, "useDashboardResource", () => $ca62b878c99c7128$export$e5e5b3f462d6a4cb);
$parcel$export(module.exports, "useMultiDashboardsResource", () => $ca62b878c99c7128$export$6a46406b05d8d13c);
$parcel$export(module.exports, "dashboardAMDModulesResource", () => $ca62b878c99c7128$export$ef3fa55626812fa4);
$parcel$export(module.exports, "useDashboardAMDModulesResource", () => $ca62b878c99c7128$export$efe0eb9a44e08d38);
$parcel$export(module.exports, "dashboardReactGadgetsResource", () => $ca62b878c99c7128$export$39804ce8cc42cd04);
$parcel$export(module.exports, "useDashboardReactGadgetsResource", () => $ca62b878c99c7128$export$31b430e01a1caab5);
$parcel$export(module.exports, "dashboardForgeResource", () => $ca62b878c99c7128$export$4e0719e53da01e93);
$parcel$export(module.exports, "gadgetDirectoryResource", () => $ca62b878c99c7128$export$36c9632be21fbb06);
$parcel$export(module.exports, "useGadgetDirectoryResource", () => $ca62b878c99c7128$export$27f4c12e781b4572);
$parcel$export(module.exports, "useDashboardForgeResource", () => $ca62b878c99c7128$export$75ca1b431898fd09);

var $k2DRb = parcelRequire("k2DRb");

var $iVaKa = parcelRequire("iVaKa");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $3Yd87 = parcelRequire("3Yd87");

var $abozY = parcelRequire("abozY");


var $04Brv = parcelRequire("04Brv");

var $3cb5I = parcelRequire("3cb5I");

var $aVFmC = parcelRequire("aVFmC");

var $3Zhqx = parcelRequire("3Zhqx");

var $8oOn8 = parcelRequire("8oOn8");
const $ca62b878c99c7128$export$2853c0e656e89346 = (0, $2M1hQ.createResource)({
    type: (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16),
    getKey: $abozY.getKey,
    getData: (0, $3cb5I.default),
    maxAge: Infinity
});
// the type signature of promise and update is different on the useDashboardResource and useMultiDashboardsResource hook
const $ca62b878c99c7128$var$extractFirstPromise = (promise)=>promise ? promise.then((configs)=>configs && configs[0]) : null;
const $ca62b878c99c7128$export$e5e5b3f462d6a4cb = ()=>{
    // the response will have different signature on update, promise and clear etc
    const resourceResponse = $ca62b878c99c7128$export$6a46406b05d8d13c();
    const { loading: loading, error: error, data: data, promise: promiseOfMultiConfigs, ...rest } = resourceResponse;
    const extractFirstUpdate = (getNewData)=>resourceResponse.update(([a])=>[
                getNewData(a)
            ]);
    // RouteResourceResponseLoading type
    if (loading) return {
        ...rest,
        error: null,
        data: null,
        promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: true,
        update: extractFirstUpdate
    };
    // RouteResourceResponseError type
    if (error) return {
        ...rest,
        error: error,
        data: null,
        promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: false,
        update: extractFirstUpdate
    };
    // RouteResourceResponseLoaded type
    if (data && !error) return {
        ...rest,
        loading: false,
        update: extractFirstUpdate,
        data: data[0],
        error: null,
        promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs)
    };
    // RouteResourceResponseInitial type
    return {
        ...rest,
        loading: false,
        error: error,
        data: null,
        promise: null,
        update: extractFirstUpdate
    };
};
const $ca62b878c99c7128$export$6a46406b05d8d13c = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$2853c0e656e89346);
const $ca62b878c99c7128$export$ef3fa55626812fa4 = (0, $3Yd87.createDependentResource)({
    type: (0, $e03099b7bef7f4cd$export$e239393fd4e2bc85),
    getKey: $abozY.getKey,
    depends: [
        (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $3Yd87.withEitherDataOrError)((data)=>{
        const { gadgets: gadgets, preloadedModuleNames: preloadedModuleNames } = data.reduce((prev, curr)=>({
                gadgets: prev.gadgets.concat(curr.gadgets),
                preloadedModuleNames: prev.preloadedModuleNames.concat(curr.preloadedModuleNames)
            }), {
            gadgets: [],
            preloadedModuleNames: []
        });
        const moduleNames = (0, $8oOn8.gadgetsToUniqueSortedAmdModules)(gadgets);
        const isPreloaded = moduleNames.every((name)=>preloadedModuleNames.includes(name));
        return {
            moduleNames: moduleNames,
            isPreloaded: isPreloaded
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, amdModules: amdModules }, b)=>(0, $3Yd87.withEitherDataOrError)((prev, next)=>next.moduleNames.length > prev.moduleNames.length || next.moduleNames.some((name)=>amdModules?.[name] == null), ()=>true)(a, b),
    getData: (0, $04Brv.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $ca62b878c99c7128$export$efe0eb9a44e08d38 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$ef3fa55626812fa4);
const $ca62b878c99c7128$export$39804ce8cc42cd04 = (0, $3Yd87.createDependentResource)({
    type: (0, $e03099b7bef7f4cd$export$9e5db01432b13b67),
    getKey: $abozY.getKey,
    depends: [
        (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $3Yd87.withEitherDataOrError)((data)=>{
        const gadgets = data.flatMap((dashboard)=>dashboard.gadgets);
        return {
            reactGadgets: (0, $8oOn8.gadgetsToSortedReactGadgets)(gadgets)
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, reactGadgetsState: reactGadgetsState }, b)=>(0, $3Yd87.withEitherDataOrError)((prev, next)=>JSON.stringify(next.reactGadgets) !== JSON.stringify(prev.reactGadgets) || reactGadgetsState != null && Object.values(reactGadgetsState).some((v)=>!v), ()=>true)(a, b),
    getData: (0, $3Zhqx.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $ca62b878c99c7128$export$31b430e01a1caab5 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$39804ce8cc42cd04);
const $ca62b878c99c7128$export$4e0719e53da01e93 = (0, $2M1hQ.createResource)({
    type: (0, $e03099b7bef7f4cd$export$bce41807cc929d0f),
    getKey: $abozY.getKey,
    getData: async (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        const modules = await (0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.DASHBOARD_GADGET_MODULE),
                (0, $k2DRb.DASHBOARD_BACKGROUND_SCRIPT_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        });
        return {
            gadgets: modules[0, $k2DRb.DASHBOARD_GADGET_MODULE],
            backgroundScripts: modules[0, $k2DRb.DASHBOARD_BACKGROUND_SCRIPT_MODULE]
        };
    },
    maxAge: Infinity
});
const $ca62b878c99c7128$export$36c9632be21fbb06 = (0, $2M1hQ.createResource)({
    type: (0, $e03099b7bef7f4cd$export$c07a25ebb6af1e84),
    getKey: ()=>'gadgetDirectoryItems',
    getData: (0, $aVFmC.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $ca62b878c99c7128$export$27f4c12e781b4572 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$36c9632be21fbb06);
const $ca62b878c99c7128$export$75ca1b431898fd09 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$4e0719e53da01e93);

});
parcelRegister("3Yd87", function(module, exports) {

$parcel$export(module.exports, "withEitherDataOrError", () => $3e606a4e02c14aae$export$54e973088fdd59a1);
$parcel$export(module.exports, "createDependentResource", () => $3e606a4e02c14aae$export$7f8dd41bdfd85a47);
$parcel$export(module.exports, "SharedValueAggregateError", () => $3e606a4e02c14aae$export$36d5102d613df7c6);

var $2M1hQ = parcelRequire("2M1hQ");
var $htn2f = parcelRequire("htn2f");
const $3e606a4e02c14aae$export$54e973088fdd59a1 = (dataFn, errorFn)=>(...args)=>{
        const invalidArgs = args.filter((v)=>v == null || v instanceof Error);
        return invalidArgs.length ? errorFn(invalidArgs[0]) : dataFn(...args);
    };
const $3e606a4e02c14aae$export$fcdc85dfc621ec7a = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new (0, $htn2f.ResourceDependencyError)(`Cannot decode dependency "${type}", it may be missing from resource depends field`);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return resourceSlice.data;
};
const $3e606a4e02c14aae$export$bee6a631bfb54474 = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new Error(`Cannot decode dependency: "${type}" must be included in the resource depends field`);
    // prefer previous value rather than error
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { loading: loading, data: data, promise: promise, error: error } = resourceSlice;
    return loading && promise ? promise.then((v)=>v, (e)=>data ?? e) : data ?? error;
};
const $3e606a4e02c14aae$export$7f8dd41bdfd85a47 = ({ type: type, depends: depends, mapToSharedValue: mapToSharedValue, shouldUpdate: shouldUpdate, getData: getData, ...rest })=>(0, $2M1hQ.createResource)({
        ...rest,
        type: type,
        depends: [
            ...depends,
            type
        ],
        getData: (dataContext, storeContext)=>{
            const { dependencies: dependencies } = dataContext;
            const prevValue = $3e606a4e02c14aae$export$fcdc85dfc621ec7a(dependencies, type);
            const valuesOrPromises = depends.map((d)=>$3e606a4e02c14aae$export$bee6a631bfb54474(dependencies, d));
            const implementation = (depDataOrErrorOrNull)=>{
                const newShared = mapToSharedValue(...depDataOrErrorOrNull);
                return prevValue == null || prevValue instanceof Error || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                shouldUpdate(prevValue, newShared) ? getData(prevValue, newShared)(dataContext, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                storeContext) : prevValue;
            };
            return valuesOrPromises.some((v)=>v instanceof Promise) ? Promise.allSettled(valuesOrPromises).then((arr)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                arr.map((v)=>v.status === 'fulfilled' ? v.value : v.reason)).then(implementation) : implementation(valuesOrPromises);
        }
    });
class $3e606a4e02c14aae$export$36d5102d613df7c6 extends Error {
    constructor({ name: name, isPrefetch: isPrefetch, sharedValue: sharedValue }){
        super(`${name} is missing dependency, prefetch [${isPrefetch}] sharedValue [${sharedValue}]`);
        this.skipSentry = true;
    }
}

});

parcelRegister("abozY", function(module, exports) {

$parcel$export(module.exports, "getKey", () => $707c98c2b1b4b40d$export$a47fb462a08de82f);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");
const $707c98c2b1b4b40d$export$a47fb462a08de82f = ({ route: route, query: query, match: { params: params } })=>{
    if (route.name === 'system-dashboard-edit') return 0, $JIPqS.SYSTEM_DASHBOARD_ID;
    if (route.name === 'dashboard-wallboard') // NOTE - Currently we will only load the first dashboard in the list
    return query.dashboardId?.split(',')[0];
    return params.dashboardId?.replace('last-visited', 'lastVisited') ?? query.selectPageId ?? 'lastVisited';
};

});
parcelRegister("JIPqS", function(module, exports) {

$parcel$export(module.exports, "GADGET_DISPLAY", () => $6c7fd970bbaee123$export$d7e1dfcefcde2410);
$parcel$export(module.exports, "MAXIMIZED_PARAM", () => $6c7fd970bbaee123$export$86eaa19ea940a4f5);
$parcel$export(module.exports, "CONNECT_ITEM_AMD_MODULE", () => $6c7fd970bbaee123$export$a1baea8b97610fd);
$parcel$export(module.exports, "WEB_RESOURCE_MAP", () => $6c7fd970bbaee123$export$c6d360a8456d120a);
$parcel$export(module.exports, "PRELOADED_GADGET_DATA_KEY", () => $6c7fd970bbaee123$export$30b970d16c2f5e0a);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_ID", () => $6c7fd970bbaee123$export$50eac80bcbebc737);
$parcel$export(module.exports, "DASHBOARD_HEADER_HEIGHT", () => $6c7fd970bbaee123$export$e11ffd0409aa6522);
$parcel$export(module.exports, "FOOTER_MARGIN", () => $6c7fd970bbaee123$export$4d708f4c16ae3a73);
$parcel$export(module.exports, "GADGET_LOCAL_STORAGE_NAME", () => $6c7fd970bbaee123$export$255117c9adec50a5);
$parcel$export(module.exports, "DASHBOARD_LOCAL_STORAGE_KEY_NAME", () => $6c7fd970bbaee123$export$e281465c09f561d4);
$parcel$export(module.exports, "GADGET_DEFAULT_HEIGHT", () => $6c7fd970bbaee123$export$46dd0168a7875b47);
$parcel$export(module.exports, "COLOR_MAP", () => $6c7fd970bbaee123$export$1468aefba37090f9);
$parcel$export(module.exports, "COLOR_NAME_MAP", () => $6c7fd970bbaee123$export$5d9e688e192a63ae);
$parcel$export(module.exports, "COLOR_CHECKMARK_MAP", () => $6c7fd970bbaee123$export$6906a4beef307ac4);
$parcel$export(module.exports, "MODAL_ID", () => $6c7fd970bbaee123$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "LAYOUTS", () => $6c7fd970bbaee123$export$87e50aced9c52ebb);
$parcel$export(module.exports, "GADGET_HEIGHT_UPDATE_WAIT_TIME", () => $6c7fd970bbaee123$export$b0234a47b1a4a515);
$parcel$export(module.exports, "GADGET_DRAG_CONTAINER_HEIGHT", () => $6c7fd970bbaee123$export$9674cd14c20d1c89);
$parcel$export(module.exports, "GADGET_METRICS_TYPE", () => $6c7fd970bbaee123$export$46b6c8eb53069613);
$parcel$export(module.exports, "PAGE_READY_METRIC_KEY", () => $6c7fd970bbaee123$export$464d2a6bcb398791);
$parcel$export(module.exports, "DELETE_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$4f74f1f13671c49d);
$parcel$export(module.exports, "COPY_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$3853fce65645c557);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE", () => $6c7fd970bbaee123$export$c8c77659771c38b9);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$707702c47e5b9648);
$parcel$export(module.exports, "CREATE_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$efbab4efa7252143);
$parcel$export(module.exports, "VIEW_DASHBOARD_EDITABLE_EXPERIENCE", () => $6c7fd970bbaee123$export$7b6f3ec1189de156);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EXPERIENCE", () => $6c7fd970bbaee123$export$f0e105144716a420);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EMBED_EXPERIENCE", () => $6c7fd970bbaee123$export$5ba84cd082269cd5);
$parcel$export(module.exports, "VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE", () => $6c7fd970bbaee123$export$6c84c6099fed3c23);
$parcel$export(module.exports, "ADD_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$3b17b4f7f722b1ae);
$parcel$export(module.exports, "SAVE_AMD_GADGET_CONFIG_PREFERENCES", () => $6c7fd970bbaee123$export$c8900d7e874d42ca);
$parcel$export(module.exports, "SAVE_FORGE_GADGET_CONFIG_PREFERENCES", () => $6c7fd970bbaee123$export$bac5a3e9d008da59);
$parcel$export(module.exports, "SAVE_CUSTOM_GADGET_TITLE_PREFERENCES", () => $6c7fd970bbaee123$export$18b54b2c53cf6acd);
$parcel$export(module.exports, "VIEW_WRM_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$a3d5b76ea0c8f4ca);
$parcel$export(module.exports, "CHANGE_LAYOUT_EXPERIENCE", () => $6c7fd970bbaee123$export$7254246f25b4cbc8);
$parcel$export(module.exports, "DELETE_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$40c4d345e57fce2d);
$parcel$export(module.exports, "VIEW_REACT_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$43fb10a4d8374f1a);
$parcel$export(module.exports, "DASHBOARD_VIEW_SOURCENAME", () => $6c7fd970bbaee123$export$2f961c74af6d8735);
$parcel$export(module.exports, "DASHBOARD_VIEW_EMBED_SOURCENAME", () => $6c7fd970bbaee123$export$dab1096b356df1cc);
$parcel$export(module.exports, "DASHBOARD_EDIT_SOURCENAME", () => $6c7fd970bbaee123$export$32f0edca4eebb9c7);
$parcel$export(module.exports, "DASHBOARD_WALLBOARD_VIEW_SOURCENAME", () => $6c7fd970bbaee123$export$791f7067c41dc5b1);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_EDIT_SOURCENAME", () => $6c7fd970bbaee123$export$eba1a497984af3ae);
$parcel$export(module.exports, "COPY_DASHBOARD", () => $6c7fd970bbaee123$export$3578044b625436f9);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH", () => $6c7fd970bbaee123$export$48bb59a846d62ea0);
$parcel$export(module.exports, "DELETE_DASHBOARD", () => $6c7fd970bbaee123$export$e7dfbcf33cf2b19a);
$parcel$export(module.exports, "DUPLICATE_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$fabf79b25b44377f);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD", () => $6c7fd970bbaee123$export$abba919f32a1a776);
$parcel$export(module.exports, "GADGET_ERROR_TYPE", () => $6c7fd970bbaee123$export$768dad6811159849);
$parcel$export(module.exports, "DASHBOARD_REFRESH_LOAD_BUFFER_MS", () => $6c7fd970bbaee123$export$ada294d471e7dfc3);
$parcel$export(module.exports, "REFRESH_LABEL_UPDATE_INTERVAL", () => $6c7fd970bbaee123$export$f4280aaeba4d1d08);
$parcel$export(module.exports, "CONNECT_GADGET_REFRESH_REQUEST_EVENT", () => $6c7fd970bbaee123$export$685171fdf5112bc4);
$parcel$export(module.exports, "FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT", () => $6c7fd970bbaee123$export$4d8c12b9aaeac619);
$parcel$export(module.exports, "ISSUE_SEARCH_DEFAULT_COLUMNS", () => $6c7fd970bbaee123$export$f07dac7b8de3bda);


var $gwIPs = parcelRequire("gwIPs");

var $cKw8Y = parcelRequire("cKw8Y");
const $6c7fd970bbaee123$export$d7e1dfcefcde2410 = {
    MAXIMIZED: 'maximized',
    NORMAL: 'normal',
    HIDDEN: 'hidden'
};
const $6c7fd970bbaee123$export$86eaa19ea940a4f5 = 'maximized';
const $6c7fd970bbaee123$export$a1baea8b97610fd = 'atlassian-connect/connect-dashboard-item';
const $6c7fd970bbaee123$export$c6d360a8456d120a = {
    'jira-dashboard-items/assigned-to-me': 'com.atlassian.jira.gadgets:assigned-to-me-dashboard-item-resources',
    'jira-dashboard-items/filter-results': 'com.atlassian.jira.gadgets:filter-results-dashboard-item-resources',
    'jira-dashboard-items/createdvsresolved': 'com.atlassian.jira.gadgets:createdvsresolved-dashboard-item-resources',
    'jira-dashboard-items/favourite-filters': 'com.atlassian.jira.gadgets:favourite-filters-dashboard-item-resources',
    'jira-dashboard-items/in-progress': 'com.atlassian.jira.gadgets:in-progress-dashboard-item-resources',
    'jira-dashboard-items/stats': 'com.atlassian.jira.gadgets:stats-dashboard-item-resources',
    'jira-dashboard-items/watched': 'com.atlassian.jira.gadgets:watched-dashboard-item-resources',
    'jira-dashboard-items/labels': 'com.atlassian.jira.gadgets:labels-dashboard-item-resources',
    'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item-resources',
    'jira-dashboard-items/piechart': 'com.atlassian.jira.gadgets:piechart-dashboard-item-resources',
    'jira-dashboard-items/voted': 'com.atlassian.jira.gadgets:voted-dashboard-item-resources',
    'jira-dashboard-items/two-dimensional-stats': 'com.atlassian.jira.gadgets:two-dimensional-stats-dashboard-item-resources',
    'jira-dashboard-items/sprint-health': 'com.pyxis.greenhopper.jira:greenhopper-sprint-health-dashboard-item-resources',
    'jira-dashboard-items/sprint-days-remaining': 'com.pyxis.greenhopper.jira:greenhopper-days-remaining-dashboard-item-resources',
    'servicedesk/internal/dashboard-items/filter/filter-dashboard-item': 'com.atlassian.servicedesk.dashboard-items-plugin:spa-filter-dashboard-item-resources',
    'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'com.atlassian.servicedesk.servicedesk-reports-plugin:custom-report-dashboard-item-resources-spa',
    'jira-dashboard-items/projects': 'com.atlassian.jira.gadgets:projects-dashboard-item-resources',
    'jira-dashboard-items/issuescalendar': 'com.atlassian.jira.ext.calendar:issues-calendar-dashboard-item-resources',
    'jira-dashboard-items/activitystream': 'com.atlassian.streams.streams-jira-plugin:activitystream-dashboard-item-resources',
    'jira-dashboard-items/recently-created': 'com.atlassian.jira.gadgets:recently-created-chart-dashboard-item-resources',
    'jira-dashboard-items/resolution-time': 'com.atlassian.jira.gadgets:resolution-time-dashboard-item-resources',
    'jira-dashboard-items/timesince': 'com.atlassian.jira.gadgets:timesince-dashboard-item-resources',
    'jira-dashboard-items/spacer': 'com.atlassian.jira.gadgets:spacer-dashboard-item-resources',
    'jira-dashboard-items/sprint-burndown': 'com.pyxis.greenhopper.jira:greenhopper-sprint-burndown-dashboard-item-resources',
    'jira-dashboard-items/workload-pie-chart': 'com.atlassian.jira.gadgets:workload-pie-chart-dashboard-item-resources',
    'jira-dashboard-items/roadmap': 'com.atlassian.jira.gadgets:roadmap-dashboard-item-resources',
    'jira-dashboard-items/average-age-chart': 'com.atlassian.jira.gadgets:average-age-chart-dashboard-item-resources',
    'jira-dashboard-items/average-time-in-status-chart': 'com.atlassian.jira.gadgets:average-time-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/average-number-of-times-in-status-chart': 'com.atlassian.jira.gadgets:average-number-of-times-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/heat-map': 'com.atlassian.jira.gadgets:heat-map-dashboard-item-resources',
    'jira-dashboard-items/time-to-first-response': 'com.atlassian.jira.gadgets:time-to-first-response-dashboard-item-resources',
    'jira-dashboard-items/rapid-view': 'com.pyxis.greenhopper.jira:greenhopper-rapid-view-dashboard-item-resources',
    'jira-dashboard-items/version-report': 'com.pyxis.greenhopper.jira:greenhopper-version-report-dashboard-item-resources'
};
const $6c7fd970bbaee123$export$30b970d16c2f5e0a = 'DASHBOARD_GADGET_PRELOADED_DATA';
const $6c7fd970bbaee123$export$50eac80bcbebc737 = '10000';
const $6c7fd970bbaee123$export$e11ffd0409aa6522 = (0, $gwIPs.gridSize) * 10;
const $6c7fd970bbaee123$export$4d708f4c16ae3a73 = (0, $gwIPs.gridSize) * 2;
const $6c7fd970bbaee123$export$255117c9adec50a5 = 'AG.congolmerate.cookie';
const $6c7fd970bbaee123$export$e281465c09f561d4 = 'dashboard-data';
const $6c7fd970bbaee123$export$46dd0168a7875b47 = 160;
const $6c7fd970bbaee123$var$COLOR_BLUE = '#2684ff';
const $6c7fd970bbaee123$var$COLOR_RED = '#ff5630';
const $6c7fd970bbaee123$var$COLOR_YELLOW = '#ffab00';
const $6c7fd970bbaee123$var$COLOR_GREEN = '#36b37e';
const $6c7fd970bbaee123$var$COLOR_TEAL = '#00b8d9';
const $6c7fd970bbaee123$var$COLOR_PURPLE = '#6554c0';
const $6c7fd970bbaee123$var$COLOR_GRAY = '#97a0af';
const $6c7fd970bbaee123$var$COLOR_WHITE = '#ffffff';
const $6c7fd970bbaee123$export$1468aefba37090f9 = {
    color1: $6c7fd970bbaee123$var$COLOR_BLUE,
    color2: $6c7fd970bbaee123$var$COLOR_RED,
    color3: $6c7fd970bbaee123$var$COLOR_YELLOW,
    color4: $6c7fd970bbaee123$var$COLOR_GREEN,
    color5: $6c7fd970bbaee123$var$COLOR_TEAL,
    color6: $6c7fd970bbaee123$var$COLOR_PURPLE,
    color7: $6c7fd970bbaee123$var$COLOR_GRAY,
    color8: $6c7fd970bbaee123$var$COLOR_WHITE
};
const $6c7fd970bbaee123$export$5d9e688e192a63ae = {
    [$6c7fd970bbaee123$var$COLOR_BLUE]: (0, $cKw8Y.default).blue,
    [$6c7fd970bbaee123$var$COLOR_RED]: (0, $cKw8Y.default).red,
    [$6c7fd970bbaee123$var$COLOR_YELLOW]: (0, $cKw8Y.default).yellow,
    [$6c7fd970bbaee123$var$COLOR_GREEN]: (0, $cKw8Y.default).green,
    [$6c7fd970bbaee123$var$COLOR_TEAL]: (0, $cKw8Y.default).teal,
    [$6c7fd970bbaee123$var$COLOR_PURPLE]: (0, $cKw8Y.default).purple,
    [$6c7fd970bbaee123$var$COLOR_GRAY]: (0, $cKw8Y.default).gray,
    [$6c7fd970bbaee123$var$COLOR_WHITE]: (0, $cKw8Y.default).white
};
const $6c7fd970bbaee123$export$6906a4beef307ac4 = {
    color1: (0, $829f609a65d26a98$exports).N10,
    color2: (0, $829f609a65d26a98$exports).N10,
    color3: (0, $829f609a65d26a98$exports).N500,
    color4: (0, $829f609a65d26a98$exports).N10,
    color5: (0, $829f609a65d26a98$exports).N500,
    color6: (0, $829f609a65d26a98$exports).N10,
    color7: (0, $829f609a65d26a98$exports).N10,
    color8: (0, $829f609a65d26a98$exports).N500
};
const $6c7fd970bbaee123$export$ebdd5a8e5b1c2de5 = {
    EDIT_LAYOUT: 'edit-layout',
    DASHBOARD_COPY: 'dashboard-copy',
    AUTOMATIC_REFRESH: 'dashboard-automatic-refresh',
    DASHBOARD_RENAME_OR_SHARE: 'dashboard-rename-or-share',
    DASHBOARD_DELETE: 'dashboard-delete',
    CONFIGURE_WALLBOARD: 'configure-wallboard',
    DASHBOARD_CREATE: 'dashboard-create-on-dashboard-page'
};
const $6c7fd970bbaee123$export$87e50aced9c52ebb = [
    'A',
    'AA',
    'AAA',
    'BA',
    'AB'
];
const $6c7fd970bbaee123$export$b0234a47b1a4a515 = 350;
const $6c7fd970bbaee123$export$9674cd14c20d1c89 = 250;
const $6c7fd970bbaee123$export$46b6c8eb53069613 = {
    REPORT: 'REPORT_GADGET_METRICS',
    TIMEOUT: 'TIMEOUT_GADGET_METRICS'
};
const $6c7fd970bbaee123$export$464d2a6bcb398791 = 'JIRA_SPA_PAGE_READY';
const $6c7fd970bbaee123$export$4f74f1f13671c49d = 'delete-dashboard';
const $6c7fd970bbaee123$export$3853fce65645c557 = 'copy-dashboard';
const $6c7fd970bbaee123$export$c8c77659771c38b9 = 'dashboard-automatic-refresh';
const $6c7fd970bbaee123$export$707702c47e5b9648 = 'rename-or-share-dashboard';
const $6c7fd970bbaee123$export$efbab4efa7252143 = 'create-dashboard';
const $6c7fd970bbaee123$export$7b6f3ec1189de156 = 'view-dashboard-editable';
const $6c7fd970bbaee123$export$f0e105144716a420 = 'view-dashboard-readonly';
const $6c7fd970bbaee123$export$5ba84cd082269cd5 = 'view-dashboard-readonly-embed';
const $6c7fd970bbaee123$export$6c84c6099fed3c23 = 'view-dashboard-wallboard-readonly';
const $6c7fd970bbaee123$export$3b17b4f7f722b1ae = 'add-gadget';
const $6c7fd970bbaee123$export$c8900d7e874d42ca = 'save-amd-gadget-config';
const $6c7fd970bbaee123$export$bac5a3e9d008da59 = 'save-forge-gadget-config';
const $6c7fd970bbaee123$export$18b54b2c53cf6acd = 'save-custom-gadget-title-config';
const $6c7fd970bbaee123$export$a3d5b76ea0c8f4ca = 'view-wrm-gadget';
const $6c7fd970bbaee123$export$7254246f25b4cbc8 = 'change-layout';
const $6c7fd970bbaee123$export$40c4d345e57fce2d = 'delete-gadget';
const $6c7fd970bbaee123$export$43fb10a4d8374f1a = 'view-react-gadget';
const $6c7fd970bbaee123$export$2f961c74af6d8735 = 'dashboardView';
const $6c7fd970bbaee123$export$dab1096b356df1cc = 'dashboardViewEmbed';
const $6c7fd970bbaee123$export$32f0edca4eebb9c7 = 'dashboardEdit';
const $6c7fd970bbaee123$export$791f7067c41dc5b1 = 'dashboardWallboardView';
const $6c7fd970bbaee123$export$eba1a497984af3ae = 'systemDashboardEdit';
const $6c7fd970bbaee123$export$3578044b625436f9 = 'copyDashboard';
const $6c7fd970bbaee123$export$48bb59a846d62ea0 = 'automaticRefresh';
const $6c7fd970bbaee123$export$e7dfbcf33cf2b19a = 'deleteDashboard';
const $6c7fd970bbaee123$export$fabf79b25b44377f = 'duplicateGadget';
const $6c7fd970bbaee123$export$abba919f32a1a776 = 'renameOrShareDashboard';
const $6c7fd970bbaee123$export$768dad6811159849 = {
    VIEW_ERROR: 'viewError',
    EDIT_ERROR: 'editError',
    CONFIG_ERROR: 'configError',
    NOT_SUPPORTED_ERROR: 'notSupportedError'
};
const $6c7fd970bbaee123$export$ada294d471e7dfc3 = 1000;
const $6c7fd970bbaee123$export$f4280aaeba4d1d08 = 30000;
const $6c7fd970bbaee123$export$685171fdf5112bc4 = 'jira_dashboard_item_refresh';
const $6c7fd970bbaee123$export$4d8c12b9aaeac619 = 'JIRA_DASHBOARD_GADGET_REFRESH';
const $6c7fd970bbaee123$export$f07dac7b8de3bda = [
    'issuetype',
    'issuekey',
    'summary',
    'priority'
];

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("cKw8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $81c05dd6e2dcad70$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $81c05dd6e2dcad70$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    blue: {
        "id": "dashboard-common.blue",
        "defaultMessage": "Blue"
    },
    red: {
        "id": "dashboard-common.red",
        "defaultMessage": "Red"
    },
    yellow: {
        "id": "dashboard-common.yellow",
        "defaultMessage": "Yellow"
    },
    green: {
        "id": "dashboard-common.green",
        "defaultMessage": "Green"
    },
    teal: {
        "id": "dashboard-common.teal",
        "defaultMessage": "Teal"
    },
    purple: {
        "id": "dashboard-common.purple",
        "defaultMessage": "Purple"
    },
    gray: {
        "id": "dashboard-common.gray",
        "defaultMessage": "Gray"
    },
    white: {
        "id": "dashboard-common.white",
        "defaultMessage": "White"
    }
});

});



const $e03099b7bef7f4cd$export$ca03ff6cc792cc16 = 'DASHBOARD_CONFIG_AND_WRM';
const $e03099b7bef7f4cd$export$e239393fd4e2bc85 = 'DASHBOARD_AMD_MODULES';
const $e03099b7bef7f4cd$export$9e5db01432b13b67 = 'DASHBOARD_REACT_GADGETS';
const $e03099b7bef7f4cd$export$bce41807cc929d0f = 'DASHBOARD_FORGE';
const $e03099b7bef7f4cd$export$c07a25ebb6af1e84 = 'DASHBOARD_GADGET_DIRECTORY';

parcelRegister("04Brv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff7f8eda58c85578$export$2e2bcd8739ae039);

var $4su49 = parcelRequire("4su49");

var $3Yd87 = parcelRequire("3Yd87");

var $1IY2I = parcelRequire("1IY2I");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff7f8eda58c85578$export$2e2bcd8739ae039 = (_maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch })=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $3Yd87.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { moduleNames: moduleNames, isPreloaded: isPreloaded } = sharedValue;
            const maybePromiseAmdModules = isPreloaded || await (0, $1IY2I.loadAmdModules)((0, $4su49.asyncWrmRequire), moduleNames) ? (0, $1IY2I.evalAmdModules)(moduleNames) : null;
            const amdModules = maybePromiseAmdModules instanceof Promise ? await maybePromiseAmdModules : maybePromiseAmdModules;
            return {
                sharedValue: sharedValue,
                amdModules: amdModules
            };
        })();
    };

});
parcelRegister("1IY2I", function(module, exports) {

$parcel$export(module.exports, "loadAmdModules", () => $d6efeb87a1192ef7$export$2c79895bd69a8d54);
$parcel$export(module.exports, "evalAmdModules", () => $d6efeb87a1192ef7$export$d74eab33af9baaea);

var $2YZCu = parcelRequire("2YZCu");

var $JIPqS = parcelRequire("JIPqS");
/**
 * Dummy implementation for a Connect gadget, as rendering and editing are
 * managed externally.
 */ class $d6efeb87a1192ef7$var$ConnectDashboardItem {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    render() {}
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    renderEdit() {}
}
const $d6efeb87a1192ef7$export$3bf37adbbdcafcc8 = (moduleName, retries = 5)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (typeof window.require !== 'function') throw new TypeError('window.require is not a function');
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.require(moduleName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // amd module could throw a non-Error
        if (error instanceof Error && /^No \S+$|^\S+ missing \S+$/.test(error.message)) {
            // some AMD modules have define() inside a require() block in which case the module is not immediately ready to be window.require()'d
            // this is due to the 4ms timeout in requirejs' require(), we need a retry logic here to make sure the module is loaded.
            // see the comment section for https://jdog.jira-dev.com/browse/WRM-71
            if (retries > 0) return new Promise((r)=>setTimeout(r, 100)).then(()=>$d6efeb87a1192ef7$export$3bf37adbbdcafcc8(moduleName, retries - 1));
        }
        throw error;
    }
};
const $d6efeb87a1192ef7$export$2c79895bd69a8d54 = async (wrmRequire, moduleNames)=>{
    if (moduleNames.length === 0) return false;
    const prefixedAmdResources = moduleNames.map((amdModule)=>(0, $JIPqS.WEB_RESOURCE_MAP)[amdModule]).map((resourceName)=>`wrc!${resourceName}`);
    try {
        // no result from the promise only the side effect of having loaded the AMD module via WRM
        await wrmRequire(prefixedAmdResources);
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.resource', `Failed to load web resources [${prefixedAmdResources.join(',')}]`, error);
        return false;
    }
};
const $d6efeb87a1192ef7$var$getSortedModuleNamesFromTuples = (tuples)=>tuples.map(([moduleName])=>moduleName).sort((a, b)=>a.localeCompare(b)).join(',');
const $d6efeb87a1192ef7$export$d74eab33af9baaea = (amdModuleNames)=>{
    const tuplesOrPromises = amdModuleNames.map((amdModuleName)=>{
        try {
            const module = amdModuleName === (0, $JIPqS.CONNECT_ITEM_AMD_MODULE) ? $d6efeb87a1192ef7$var$ConnectDashboardItem : $d6efeb87a1192ef7$export$3bf37adbbdcafcc8(amdModuleName);
            return module instanceof Promise ? module.then((v)=>[
                    amdModuleName,
                    v
                ]) : [
                amdModuleName,
                module
            ];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return Promise.reject(error);
        }
    });
    const hasPromise = tuplesOrPromises.some((entry)=>entry instanceof Promise);
    if (!hasPromise) {
        (0, $2YZCu.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful synchronous bulk eval AMD modules');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Object.fromEntries(tuplesOrPromises);
    }
    return Promise.allSettled(tuplesOrPromises).then((results)=>{
        const tuples = results.map((result, i)=>{
            if (result.status === 'fulfilled') return result.value;
            const { reason: error } = result;
            const amdModuleName = amdModuleNames[i];
            const message = error instanceof Error ? error.message : String(error);
            (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD module [${amdModuleName}] with error [${message}]`, error);
            return [
                amdModuleName,
                null
            ];
        });
        const failedTuples = tuples.filter((module)=>module[1] === null);
        failedTuples.length > 0 ? (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD modules [${$d6efeb87a1192ef7$var$getSortedModuleNamesFromTuples(failedTuples)}]`) : (0, $2YZCu.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful asynchronous bulk eval AMD modules');
        return Object.fromEntries(tuples);
    });
};

});


parcelRegister("3cb5I", function(module, exports) {

$parcel$export(module.exports, "default", () => $f465c16c9ac91f45$export$2e2bcd8739ae039);

var $7RGnr = parcelRequire("7RGnr");

var $2YZCu = parcelRequire("2YZCu");

var $2j5ho = parcelRequire("2j5ho");

var $1LNzH = parcelRequire("1LNzH");

var $hoLk6 = parcelRequire("hoLk6");

var $6T8HZ = parcelRequire("6T8HZ");

var $abozY = parcelRequire("abozY");

var $8oOn8 = parcelRequire("8oOn8");
const $f465c16c9ac91f45$var$generateScriptTagAndPreloadedModuleNames = async (configs)=>{
    const gadgets = configs.flatMap((config)=>config.gadgets);
    const preloadedModuleNames = (0, $8oOn8.gadgetsToUniqueSortedAmdModules)(gadgets);
    const wrmBundleDescriptor = await (0, $1LNzH.default)(preloadedModuleNames);
    return configs.map((config)=>{
        const scriptTags = [
            wrmBundleDescriptor ? (0, $6T8HZ.default)(wrmBundleDescriptor) : null,
            (0, $hoLk6.default)(config)
        ].filter(Boolean).join('\n') || null;
        return {
            ...config,
            scriptTags: scriptTags,
            preloadedModuleNames: preloadedModuleNames
        };
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f465c16c9ac91f45$export$2e2bcd8739ae039 = async (context)=>{
    // this is either for single dashboard/wallboard or wallboard slide show with multiple dashboards
    try {
        const { route: route, query: query } = context;
        const originalConfigs = route.name === 'dashboard-wallboard' ? await (0, $2j5ho.getDashboardsConfig)(query.dashboardId) : [
            await (0, $2j5ho.default)((0, $abozY.getKey)(context))
        ];
        const configs = originalConfigs.map((config)=>({
                ...config,
                gadgets: (0, $7RGnr.mapToReactGadgets)(config.gadgets)
            }));
        if (!false) return configs.map((config)=>({
                ...config,
                preloadedModuleNames: []
            }));
        return $f465c16c9ac91f45$var$generateScriptTagAndPreloadedModuleNames(configs);
    } catch (error) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.get-config-and-wrm-data', `Failed to get dashboard configuration and wrm data: route=[${context.route.name}], query=[${JSON.stringify(context.query)}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};

});
parcelRegister("7RGnr", function(module, exports) {

$parcel$export(module.exports, "mapToReactGadgets", () => $119a071fe5fec8f8$export$c90615c5eb218d50);

var $4R6GH = parcelRequire("4R6GH");
const $119a071fe5fec8f8$export$c90615c5eb218d50 = (gadgets)=>{
    const gadgetMapping = {
        ...(0, $4R6GH.fg)('endeavour_nin_filter_results_gadget') ? {
            'jira-dashboard-items/filter-results': 'react/filter-results'
        } : {},
        'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'react/custom-report',
        ...(0, $4R6GH.fg)('endeavour_nin_assigned_to_me_gadget') ? {
            'jira-dashboard-items/assigned-to-me': 'react/assigned-to-me'
        } : {},
        ...(0, $4R6GH.fg)('endeavour_nin_issues_in_progress_gadget') ? {
            'jira-dashboard-items/in-progress': 'react/issues-in-progress'
        } : {},
        ...(0, $4R6GH.fg)('endeavour_nin_voted_issues_gadget') ? {
            'jira-dashboard-items/voted': 'react/voted-issues'
        } : {},
        ...(0, $4R6GH.fg)('endeavour_nin_watched_issues_gadget') ? {
            'jira-dashboard-items/watched': 'react/watched-issues'
        } : {}
    }; // satisfies Record<string, ReactKey>; SSR image build Thread Loader doesn't understand 'satisfies'
    const isMapped = (module)=>module !== undefined && module in gadgetMapping;
    return gadgets.map((gadget)=>{
        if (isMapped(gadget.amdModule)) return {
            ...gadget,
            reactKey: gadgetMapping[gadget.amdModule],
            amdModule: undefined,
            configurable: false,
            inlineHtml: undefined
        };
        return gadget;
    });
};

});

parcelRegister("2j5ho", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef874ace7c3cd69$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getDashboardsConfig", () => $3ef874ace7c3cd69$export$1264b6af3adf5084);

var $7f4tk = parcelRequire("7f4tk");

var $2YZCu = parcelRequire("2YZCu");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3ef874ace7c3cd69$export$2e2bcd8739ae039 = async (id)=>{
    try {
        return (0, $7f4tk.default)(`/rest/dashboards/1.0/${id}.json`);
    } catch (error) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.fetch-dashboard-config', `Failed to get dashboard config json with id=[${id}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};
const $3ef874ace7c3cd69$export$1264b6af3adf5084 = async (idsCsv)=>{
    try {
        return (0, $7f4tk.default)(`/rest/dashboards/1.0?dashboardId=${idsCsv}`);
    } catch (error) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.fetch-dashboard-config', `Failed to get dashboard config with ids=[${idsCsv}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};

});

parcelRegister("1LNzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e5794ac0c0d1780$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");

var $7f4tk = parcelRequire("7f4tk");

var $2YZCu = parcelRequire("2YZCu");
const $1e5794ac0c0d1780$var$CRITICAL_DEPENDENCIES = [
    'jira.webresources:util',
    'jira.webresources:feature-flags',
    'com.atlassian.jira.jira-atlaskit-plugin:overrides-general'
];
const $1e5794ac0c0d1780$var$JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1e5794ac0c0d1780$export$2e2bcd8739ae039 = async (moduleNames)=>{
    if (moduleNames.length === 0) return Promise.resolve(null);
    const contextsToRequire = moduleNames.map((amdModule)=>(0, $JIPqS.WEB_RESOURCE_MAP)[amdModule]);
    const payload = {
        r: [],
        c: [
            ...$1e5794ac0c0d1780$var$CRITICAL_DEPENDENCIES,
            ...contextsToRequire
        ],
        xc: [
            $1e5794ac0c0d1780$var$JIRA_HERITAGE_CRITICAL_BATCH
        ],
        xr: []
    };
    try {
        return (0, $7f4tk.default)('/rest/webResources/1.0/resources?operation=FetchWRMData', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    } catch (error) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.wrm-bundle-descriptor', `Failed to fetch wrm bundle with contexts [${contextsToRequire.join(',')}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};

});

parcelRegister("hoLk6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9b2d88076d11343$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");

var $83oax = parcelRequire("83oax");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d9b2d88076d11343$export$2e2bcd8739ae039 = (dashboardConfig)=>{
    if (dashboardConfig.gadgets.length === 0) return null;
    const prefetches = (0, $83oax.getPrefetches)(dashboardConfig);
    const preloadLinks = prefetches.map((prefetch)=>`<link rel="preload" as="fetch" href="${prefetch.url}" crossorigin="anonymous" />`).join('\n') || null;
    const syncPrefetchUrls = prefetches.filter((prefetch)=>prefetch.isSyncLoadingSupported()).map((prefetch)=>prefetch.url);
    if (preloadLinks != null && syncPrefetchUrls.length > 0) {
        const fetchScript = `
            <script type="text/javascript" data-defer-skip>
                const preloadUrls = ${JSON.stringify(syncPrefetchUrls)};
                window['${(0, $JIPqS.PRELOADED_GADGET_DATA_KEY)}'] = {};

                preloadUrls.forEach((preloadUrl) => {
                    fetch(preloadUrl)
                        .then(res => res.json())
                        .then(data => {
                            window['${(0, $JIPqS.PRELOADED_GADGET_DATA_KEY)}'][preloadUrl] = data;
                        });
                });
            </script>
        `;
        return preloadLinks + fetchScript;
    }
    return preloadLinks;
};

});
parcelRegister("83oax", function(module, exports) {

$parcel$export(module.exports, "getPrefetches", () => $6e3ee08c53b7707c$export$3144db3718ad5e57);

var $bT0sh = parcelRequire("bT0sh");
const $6e3ee08c53b7707c$export$3144db3718ad5e57 = ({ gadgets: gadgets })=>{
    const lookup = (0, $bT0sh.getPrefetchDict)();
    return gadgets.flatMap((gadget)=>{
        const identifier = gadget.amdModule;
        const prefechProp = identifier != null ? lookup[identifier] : undefined;
        if (!prefechProp || !prefechProp.enabled) return [];
        const { func: func, priority: priority, isSyncLoadingSupported: isSyncLoadingSupported } = prefechProp;
        return func(gadget).map((url)=>({
                url: url,
                priority: priority,
                isSyncLoadingSupported: isSyncLoadingSupported
            }));
    });
};

});
parcelRegister("bT0sh", function(module, exports) {

$parcel$export(module.exports, "getPrefetchDict", () => $e3f3a590c57f26d7$export$244cea94cab19e07);

var $4R6GH = parcelRequire("4R6GH");

var $ltNbR = parcelRequire("ltNbR");

var $8lc67 = parcelRequire("8lc67");

var $cdUf4 = parcelRequire("cdUf4");
const $e3f3a590c57f26d7$export$244cea94cab19e07 = ()=>({
        'jira-dashboard-items/activitystream': {
            func: (0, $8lc67.getActivityStreamPrefetchLink),
            priority: (0, $ltNbR.LOADING_PRIORITY).HIGH,
            enabled: true,
            isSyncLoadingSupported: ()=>false
        },
        'jira-dashboard-items/filter-results': {
            func: (0, $cdUf4.getFilterResultsPrefetchLink),
            priority: (0, $ltNbR.LOADING_PRIORITY).LOW,
            enabled: !(0, $4R6GH.fg)('endeavour_nin_filter_results_gadget'),
            isSyncLoadingSupported: ()=>true
        }
    });

});
parcelRegister("ltNbR", function(module, exports) {

$parcel$export(module.exports, "LOADING_PRIORITY", () => $5a106311215627b2$export$cb9b1f2232733c1b);
const $5a106311215627b2$export$cb9b1f2232733c1b = {
    HIGH: 'preload',
    LOW: 'prefetch'
};

});

parcelRegister("8lc67", function(module, exports) {

$parcel$export(module.exports, "getActivityStreamPrefetchLink", () => $cadf517d0dd42b8b$export$360928f5bf059a9e);

var $ebyGx = parcelRequire("ebyGx");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cadf517d0dd42b8b$var$replacer = (match, part1)=>String.fromCharCode(part1);
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#63-81
// @ts-expect-error - TS7006 - Parameter 'operatorLower' implicitly has an 'any' type.
const $cadf517d0dd42b8b$var$getDateValue = (dateValue, operatorLower)=>{
    // make sure we're dealing with a string so we can use indexOf and split without errors
    const dateStr = `${dateValue}`;
    const operator = operatorLower.toUpperCase();
    let dateArr;
    if (dateStr.indexOf(' ') !== -1) dateArr = dateStr.split(' ');
    else if (operator === 'BETWEEN') dateArr = [
        dateValue,
        dateValue
    ];
    else dateArr = [
        dateValue
    ];
    return dateArr.map((date, index)=>{
        // make sure we're adding numbers and not concatenating strings
        const dateInt = parseInt(date, 10);
        if (operator === 'AFTER' || operator === 'BETWEEN' && index === 1) return dateInt + 86400000 - 1; // Add 23 hours, 59 minutes, 59 seconds to get to end of day
        return dateInt;
    }).join(' ');
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#20
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cadf517d0dd42b8b$var$handleSpecialCases = (rule)=>{
    let { value: value, operator: operator } = rule;
    const { type: type } = rule;
    if (Array.isArray(value)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const encodedValues = [];
        value.forEach((val)=>{
            // additional level of encoding for spaces because otherwise the spaces
            // will be mistaken for value delimiters (STRM-1857); escape space as "_"
            // and escape any existing "_" as "\_"
            encodedValues.push(val.replace(/_/g, '\\_').replace(/ /g, '_'));
        });
        value = encodedValues.join(' ');
    }
    if (type === 'date') {
        if (operator === 'is') // back end doesn't support "IS", we have to turn it into a between
        operator = 'between';
        value = $cadf517d0dd42b8b$var$getDateValue(value, operator);
        // We had some problems getting the date values
        // Return empty rule so it won't be included
        if (value.indexOf('NaN') !== -1) return {};
    } else if (type === 'list' || type === 'user') {
        // allow comma-separated values (in addition to space separated) for issue keys and usernames
        value = value.replace(/,/g, ' ');
        // escape underscores as "\_" (because "_" is used to escape spaces in lists)
        value = value.replace(/_/g, '\\_');
    }
    return {
        value: value,
        operator: operator
    };
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#651-683
const $cadf517d0dd42b8b$var$getParamsFromRules = (rules)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params = {};
    const providers = JSON.parse(decodeURIComponent(rules.replace(/&#([0-9]+);/g, $cadf517d0dd42b8b$var$replacer)))?.providers || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const enabledProviders = [];
    // @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    providers.forEach((provider)=>{
        const providerKey = provider.provider;
        const { rules: providerRules } = provider;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stringifiedRules = [];
        if (!provider.disabled) {
            if (providerKey !== 'streams') enabledProviders.push(providerKey);
            // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
            providerRules.forEach((rule)=>{
                const modifiedRuleObj = $cadf517d0dd42b8b$var$handleSpecialCases(rule);
                const { operator: operator, value: value } = modifiedRuleObj;
                if (operator && value) stringifiedRules.push([
                    rule.rule,
                    operator.toUpperCase(),
                    value
                ].join(' '));
            });
            params[providerKey] = stringifiedRules;
        }
    });
    if (enabledProviders.length < providers.length - 1) params.providers = enabledProviders.join(' ');
    return params;
};
const $cadf517d0dd42b8b$export$3d7deb7cf8a9de04 = (gadget)=>{
    const prefs = Object.fromEntries(gadget.userPrefs?.fields.map((field)=>[
            field.name,
            field.value
        ]) ?? []);
    const params = {
        maxResults: prefs.numofentries ?? 25,
        relativeLinks: true,
        ...prefs.rules ? $cadf517d0dd42b8b$var$getParamsFromRules(prefs.rules) : {}
    };
    // Gadget encodes spaces as '+', rather than '%20'.  Need to replace here to match URL exactly.
    return (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(params).replace(/%20/g, '+');
};
const $cadf517d0dd42b8b$var$ACTIVITY_STREAM_REST_URL = 'plugins/servlet/streams';
const $cadf517d0dd42b8b$export$360928f5bf059a9e = (gadgetData)=>{
    const paramStr = $cadf517d0dd42b8b$export$3d7deb7cf8a9de04(gadgetData);
    return [
        `/${$cadf517d0dd42b8b$var$ACTIVITY_STREAM_REST_URL}?${paramStr}`
    ];
};

});

parcelRegister("cdUf4", function(module, exports) {

$parcel$export(module.exports, "getFilterResultsPrefetchLink", () => $7e69dbaeb4189994$export$947cd90004054337);

var $ebyGx = parcelRequire("ebyGx");
const $7e69dbaeb4189994$var$FILTER_RESULTS_REST_URL = 'rest/gadget/1.0/issueTable';
const $7e69dbaeb4189994$export$947cd90004054337 = (gadgetData)=>{
    const { properties: properties } = gadgetData.context.dashboardItem;
    const data = {
        num: properties.num,
        tableContext: 'jira.table.cols.dashboard',
        addDefault: false,
        columnNames: typeof properties.columnNames === 'string' ? properties.columnNames.split('|') : undefined,
        enableSorting: true,
        paging: true,
        showActions: true,
        filterId: undefined,
        jql: undefined,
        sortBy: String(properties.sortBy && properties.sortBy !== '' ? properties.sortBy : null),
        startIndex: properties.startIndex ? properties.startIndex : 0
    };
    let queryType = '';
    if (properties.filterId) {
        queryType = 'filter';
        Object.assign(data, {
            filterId: properties.filterId
        });
    } else if (properties.jql) {
        queryType = 'jql';
        Object.assign(data, {
            jql: properties.jql
        });
    }
    // IMPORTANT - type definitions are incorrect, sort is definitely an option
    // @see https://www.npmjs.com/package/query-string/v/5.1.0
    // @ts-expect-error - TS2345 - Argument of type '{ sort: boolean; }' is not assignable to parameter of type 'StringifyOptions'.
    const paramStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(data, {
        sort: false
    }).replace(/%20/g, '+');
    const preloadUrl = `/${$7e69dbaeb4189994$var$FILTER_RESULTS_REST_URL}/${queryType}?${paramStr}`;
    return [
        preloadUrl
    ];
};

});




parcelRegister("6T8HZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c547330881220e9$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c547330881220e9$export$2e2bcd8739ae039 = (response)=>{
    let resourceHtml = `
        <script type="text/javascript" data-defer-skip>
            window.WRM=window.WRM||{};window.WRM._unparsedData=window.WRM._unparsedData||{};window.WRM._unparsedErrors=window.WRM._unparsedErrors||{};
            WRM._unparsedData = Object.assign({}, WRM._unparsedData, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedData))}));
            WRM._unparsedErrors = Object.assign({}, WRM._unparsedErrors, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedErrors))}));
            if(window.WRM._dataArrived)window.WRM._dataArrived();
        </script>
    `;
    response.resources.forEach((resource)=>{
        const { url: url, resourceType: resourceType, key: key } = resource;
        if (resourceType === 'CSS') {
            const cssResource = `<link
                href=${url}
                type="text/css"
                rel="stylesheet"
                media="all"
                data-wrm-key=${key}
                data-wrm-batch-type="context"
            />`;
            resourceHtml += cssResource;
        } else {
            const jsResource = `<div>
                <script
                    type="text/javascript"
                    data-initially-rendered
                    data-defer-skip
                    src=${url}
                    data-wrm-key=${key}
                    data-wrm-batch-type="context"
                ></script>
            </div>`;
            resourceHtml += jsResource;
        }
    });
    return resourceHtml;
};

});

parcelRegister("8oOn8", function(module, exports) {

$parcel$export(module.exports, "gadgetsToUniqueSortedAmdModules", () => $d83f51a78c4f458b$export$598e0ea2a7525181);
$parcel$export(module.exports, "gadgetsToSortedReactGadgets", () => $d83f51a78c4f458b$export$f98787198c197952);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");

var $kspzT = parcelRequire("kspzT");
const $d83f51a78c4f458b$export$598e0ea2a7525181 = (gadgets)=>gadgets // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .map(({ amdModule: amdModule })=>amdModule) // validated below
    .filter(Boolean).filter((amdModule)=>amdModule in (0, $JIPqS.WEB_RESOURCE_MAP)).filter((v, i, a)=>a.indexOf(v) === i).sort() ?? [];
const $d83f51a78c4f458b$export$f98787198c197952 = (gadgets)=>gadgets.reduce((gadgetsAccumulator, gadget)=>{
        if (!(0, $kspzT.isReactKey)(gadget.reactKey)) return gadgetsAccumulator;
        gadgetsAccumulator.push({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            reactKey: gadget.reactKey,
            id: gadget.id,
            userPrefs: gadget.userPrefs
        });
        return gadgetsAccumulator;
    }, []).sort((a, b)=>a.id.localeCompare(b.id));

});
parcelRegister("kspzT", function(module, exports) {

$parcel$export(module.exports, "isReactKey", () => $7a81ea406ace6c08$export$6acd06c99f745b49);
$parcel$export(module.exports, "default", () => $7a81ea406ace6c08$export$2e2bcd8739ae039);

var $9zbBl = parcelRequire("9zbBl");

var $kvkwL = parcelRequire("kvkwL");

var $26UOd = parcelRequire("26UOd");
/** This is a gadgets definition file.  */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a81ea406ace6c08$var$GADGETS_DEFINITION = {
    [(0, $26UOd.REACT_KEY).FILTER_RESULTS]: (0, $kvkwL.FILTER_RESULTS_DEFINITION),
    [(0, $26UOd.REACT_KEY).ASSIGNED_TO_ME]: (0, $kvkwL.ASSIGNED_TO_ME_DEFINITION),
    [(0, $26UOd.REACT_KEY).ISSUES_IN_PROGRESS]: (0, $kvkwL.ISSUES_IN_PROGRESS_DEFINITION),
    [(0, $26UOd.REACT_KEY).VOTED_ISSUES]: (0, $kvkwL.VOTED_ISSUES_DEFINITION),
    [(0, $26UOd.REACT_KEY).WATCHED_ISSUES]: (0, $kvkwL.WATCHED_ISSUES_DEFINITION),
    [(0, $26UOd.REACT_KEY).CUSTOM_REPORT]: (0, $9zbBl.default)
};
function $7a81ea406ace6c08$export$6acd06c99f745b49(key) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return !!(key && Object.values((0, $26UOd.REACT_KEY)).includes(key));
}
var $7a81ea406ace6c08$export$2e2bcd8739ae039 = $7a81ea406ace6c08$var$GADGETS_DEFINITION;

});
parcelRegister("9zbBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $088534adc4ba7ffc$export$2e2bcd8739ae039);

var $cDOH2 = parcelRequire("cDOH2");

var $jUheV = parcelRequire("jUheV");

var $gM7kh = parcelRequire("gM7kh");
const $088534adc4ba7ffc$var$CUSTOM_REPORT_DEFINITION = {
    componentView: (0, $jUheV.LazyCustomReportGadgetView),
    componentEdit: (0, $cDOH2.LazyCustomReportGadgetEdit),
    getInitialState: $gM7kh.default,
    preload: $jUheV.preload
};
var $088534adc4ba7ffc$export$2e2bcd8739ae039 = $088534adc4ba7ffc$var$CUSTOM_REPORT_DEFINITION;

});
parcelRegister("cDOH2", function(module, exports) {

$parcel$export(module.exports, "LazyCustomReportGadgetEdit", () => $e8ab1a4d1d8a6eb4$export$475e4a6fb8f40116);

var $kxZPA = parcelRequire("kxZPA");

const $e8ab1a4d1d8a6eb4$export$475e4a6fb8f40116 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("g9rOr")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/edit/main.tsx"
});

});
parcelRegister("g9rOr", function(module, exports) {

let $bc230f973d976e94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc230f973d976e94$var$load("g1EA5").then(()=>parcelRequire('chhAm'));

});


parcelRegister("jUheV", function(module, exports) {

$parcel$export(module.exports, "LazyCustomReportGadgetView", () => $e43675722e4e42c6$export$27df795d4f3ff173);
$parcel$export(module.exports, "preload", () => $e43675722e4e42c6$export$513ccb98c53b8039);

var $kxZPA = parcelRequire("kxZPA");

const $e43675722e4e42c6$export$27df795d4f3ff173 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5buDe")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/view/main.tsx"
});
const { preload: $e43675722e4e42c6$export$513ccb98c53b8039 } = $e43675722e4e42c6$export$27df795d4f3ff173;

});
parcelRegister("5buDe", function(module, exports) {

let $3c65bda4cdb9eab5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c65bda4cdb9eab5$var$load("j2DU4").then(()=>parcelRequire('e2l8c'));

});


parcelRegister("gM7kh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1132aa73a645b93$export$2e2bcd8739ae039);
const $d1132aa73a645b93$var$getInitialState = ()=>Promise.resolve({
        intervalValue: '1',
        isCustom: 'false',
        projectValue: '0',
        refresh: 'false',
        reportValue: '0',
        gadgetContentTitle: ''
    });
var $d1132aa73a645b93$export$2e2bcd8739ae039 = $d1132aa73a645b93$var$getInitialState;

});


parcelRegister("kvkwL", function(module, exports) {

$parcel$export(module.exports, "FILTER_RESULTS_DEFINITION", () => $676d00abfb59f2ab$export$3581891d04da6bb8);
$parcel$export(module.exports, "ASSIGNED_TO_ME_DEFINITION", () => $676d00abfb59f2ab$export$652d5a9cc2c18d2e);
$parcel$export(module.exports, "ISSUES_IN_PROGRESS_DEFINITION", () => $676d00abfb59f2ab$export$54b46348d1ed5d22);
$parcel$export(module.exports, "VOTED_ISSUES_DEFINITION", () => $676d00abfb59f2ab$export$ea96ce30d34ce354);
$parcel$export(module.exports, "WATCHED_ISSUES_DEFINITION", () => $676d00abfb59f2ab$export$5109728db227eae);

var $5uXOq = parcelRequire("5uXOq");

var $2egG3 = parcelRequire("2egG3");

var $eZ5lN = parcelRequire("eZ5lN");

var $kdIR9 = parcelRequire("kdIR9");

var $dzPNh = parcelRequire("dzPNh");

var $9KhHm = parcelRequire("9KhHm");

var $5ALJk = parcelRequire("5ALJk");

var $hfHPa = parcelRequire("hfHPa");
const $676d00abfb59f2ab$var$componentViewWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $676d00abfb59f2ab$var$componentEditWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG = {
    testId: 'react-issue-table-gadgets.filter-results.view'
};
const $676d00abfb59f2ab$export$3581891d04da6bb8 = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG),
    componentEdit: (0, $eZ5lN.FilterResultsGadgetEdit),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG = {
    predeterminedJql: 'assignee = currentUser() AND statusCategory != 3 ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.assigned-to-me.view'
};
const $676d00abfb59f2ab$export$652d5a9cc2c18d2e = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $2egG3.AssignedToMeGadgetEdit), $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG = {
    predeterminedJql: 'status = "In Progress" AND statusCategory != Done AND assignee = currentUser() ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.issues-in-progress.view'
};
const $676d00abfb59f2ab$export$54b46348d1ed5d22 = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $kdIR9.IssuesInProgressGadgetEdit), $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in votedIssues() AND statusCategory != Done ORDER BY votes DESC',
    predeterminedJqlIncludeResolved: 'issue in votedIssues() ORDER BY votes DESC',
    defaultSortPrefs: {
        field: 'votes',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.voted-issues.view'
};
const $676d00abfb59f2ab$export$ea96ce30d34ce354 = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $9KhHm.VotedIssuesGadgetEdit), $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in watchedIssues() AND statusCategory != Done ORDER BY watchers DESC',
    predeterminedJqlIncludeResolved: 'issue in watchedIssues() ORDER BY watchers DESC',
    defaultSortPrefs: {
        field: 'watchers',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.watched-issues.view'
};
const $676d00abfb59f2ab$export$5109728db227eae = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $5ALJk.WatchedIssuesGadgetEdit), $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
    preload: (0, $dzPNh.preload)
};

});
parcelRegister("2egG3", function(module, exports) {

$parcel$export(module.exports, "AssignedToMeGadgetEdit", () => $91d75e80303bba8c$export$3ae3568d16dc8f35);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5a5jN")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/assigned-to-me/edit/main.tsx"
});
const $91d75e80303bba8c$export$3ae3568d16dc8f35 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "assigned-to-me-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit, props));
const { preload: $91d75e80303bba8c$export$513ccb98c53b8039 } = $91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit;

});
parcelRegister("834mM", function(module, exports) {

$parcel$export(module.exports, "FilterResultsEditSkeleton", () => $92b82de956011a8a$export$e10d91ce257e7374);
/* filter-results-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $ewt3o = parcelRequire("ewt3o");
const $92b82de956011a8a$var$customCssStyles = null;
const $92b82de956011a8a$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT = '698px';
const $92b82de956011a8a$export$e10d91ce257e7374 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ewt3o))),
        containerStyles: {
            height: $92b82de956011a8a$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT
        },
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("ewt3o", function(module, exports) {
module.exports = new URL("filter-results-edit-skeleton.tpl.783fb7b7.svg", import.meta.url).toString();

});


parcelRegister("5a5jN", function(module, exports) {

let $3c2203072df5cc15$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $3c2203072df5cc15$var$load("czifk"),
            $3c2203072df5cc15$var$load("l253H"),
            $3c2203072df5cc15$var$load("76n7a"),
            $3c2203072df5cc15$var$load("kvRbA"),
            $3c2203072df5cc15$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $3c2203072df5cc15$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $3c2203072df5cc15$var$load("cTJTG"),
            $3c2203072df5cc15$var$load("l253H"),
            $3c2203072df5cc15$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $3c2203072df5cc15$var$load("4Qxp7")
        ]);
    }),
    $3c2203072df5cc15$var$load("kNFvF"),
    $3c2203072df5cc15$var$load("ffQaD"),
    $3c2203072df5cc15$var$load("kvRbA"),
    $3c2203072df5cc15$var$load("fliVL"),
    $3c2203072df5cc15$var$load("g7OWt")
]).then(()=>parcelRequire('1SEAb'));

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});



parcelRegister("eZ5lN", function(module, exports) {

$parcel$export(module.exports, "FilterResultsGadgetEdit", () => $fa7c1c640e166488$export$6dfceca003c43832);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $fa7c1c640e166488$var$LazyFilterResultsGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dx604")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/filter-results/edit/main.tsx"
});
const $fa7c1c640e166488$export$6dfceca003c43832 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "filter-results-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa7c1c640e166488$var$LazyFilterResultsGadgetEdit, props));
const { preload: $fa7c1c640e166488$export$513ccb98c53b8039 } = $fa7c1c640e166488$var$LazyFilterResultsGadgetEdit;

});
parcelRegister("dx604", function(module, exports) {

let $9da302eee8f36476$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $9da302eee8f36476$var$load("czifk"),
            $9da302eee8f36476$var$load("l253H"),
            $9da302eee8f36476$var$load("76n7a"),
            $9da302eee8f36476$var$load("kvRbA"),
            $9da302eee8f36476$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $9da302eee8f36476$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $9da302eee8f36476$var$load("cTJTG"),
            $9da302eee8f36476$var$load("l253H"),
            $9da302eee8f36476$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $9da302eee8f36476$var$load("4Qxp7")
        ]);
    }),
    $9da302eee8f36476$var$load("kNFvF"),
    $9da302eee8f36476$var$load("ffQaD"),
    $9da302eee8f36476$var$load("kvRbA"),
    $9da302eee8f36476$var$load("fliVL"),
    $9da302eee8f36476$var$load("1kIEc")
]).then(()=>parcelRequire('eKgKX'));

});


parcelRegister("kdIR9", function(module, exports) {

$parcel$export(module.exports, "IssuesInProgressGadgetEdit", () => $04f85077310bce7f$export$199fec410a0f70a2);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3AlQz")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/issues-in-progress/edit/main.tsx"
});
const $04f85077310bce7f$export$199fec410a0f70a2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issues-in-progress-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit, props));
const { preload: $04f85077310bce7f$export$513ccb98c53b8039 } = $04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit;

});
parcelRegister("3AlQz", function(module, exports) {

let $29c5ae3d5935b88c$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $29c5ae3d5935b88c$var$load("czifk"),
            $29c5ae3d5935b88c$var$load("l253H"),
            $29c5ae3d5935b88c$var$load("76n7a"),
            $29c5ae3d5935b88c$var$load("kvRbA"),
            $29c5ae3d5935b88c$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $29c5ae3d5935b88c$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $29c5ae3d5935b88c$var$load("cTJTG"),
            $29c5ae3d5935b88c$var$load("l253H"),
            $29c5ae3d5935b88c$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $29c5ae3d5935b88c$var$load("4Qxp7")
        ]);
    }),
    $29c5ae3d5935b88c$var$load("kNFvF"),
    $29c5ae3d5935b88c$var$load("ffQaD"),
    $29c5ae3d5935b88c$var$load("kvRbA"),
    $29c5ae3d5935b88c$var$load("fliVL"),
    $29c5ae3d5935b88c$var$load("hgF8H")
]).then(()=>parcelRequire('dk51x'));

});


parcelRegister("dzPNh", function(module, exports) {

$parcel$export(module.exports, "IssueTableGadgetView", () => $0c0c24e495111ec5$export$da0765a3c10e16a3);
$parcel$export(module.exports, "preload", () => $0c0c24e495111ec5$export$513ccb98c53b8039);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $lfTZh = parcelRequire("lfTZh");

var $dNZVN = parcelRequire("dNZVN");

var $kxZPA = parcelRequire("kxZPA");

const $0c0c24e495111ec5$var$LazyIssueTableGadgetView = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9CdoX")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/view/main.tsx"
});
const $0c0c24e495111ec5$export$da0765a3c10e16a3 = ({ customSkeletonHeightInPx: customSkeletonHeightInPx, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "filter-results-gadget-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dNZVN.FilterResultsIssueTableSkeleton), {
            height: `${customSkeletonHeightInPx ?? (0, $JIPqS.GADGET_DEFAULT_HEIGHT)}px`
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c0c24e495111ec5$var$LazyIssueTableGadgetView, {
        customSkeletonHeightInPx: customSkeletonHeightInPx,
        ...props
    }));
const { preload: $0c0c24e495111ec5$export$513ccb98c53b8039 } = $0c0c24e495111ec5$var$LazyIssueTableGadgetView;

});
parcelRegister("dNZVN", function(module, exports) {

$parcel$export(module.exports, "FilterResultsIssueTableSkeleton", () => $a73c71eae267b518$export$35d754053deeac73);
/* filter-results-issue-table.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $iMQ64 = parcelRequire("iMQ64");
const $a73c71eae267b518$var$customCssStyles = null;
const $a73c71eae267b518$export$35d754053deeac73 = ({ height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iMQ64))),
        containerStyles: {
            height: height
        },
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("iMQ64", function(module, exports) {
module.exports = new URL("filter-results-issue-table-skeleton.tpl.a502204a.svg", import.meta.url).toString();

});


parcelRegister("9CdoX", function(module, exports) {

let $70020ef2e0d063e5$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $70020ef2e0d063e5$var$load("czifk"),
            $70020ef2e0d063e5$var$load("l253H"),
            $70020ef2e0d063e5$var$load("76n7a"),
            $70020ef2e0d063e5$var$load("kvRbA"),
            $70020ef2e0d063e5$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $70020ef2e0d063e5$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $70020ef2e0d063e5$var$load("cTJTG"),
            $70020ef2e0d063e5$var$load("l253H"),
            $70020ef2e0d063e5$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $70020ef2e0d063e5$var$load("4Qxp7")
        ]);
    }),
    $70020ef2e0d063e5$var$load("kNFvF"),
    $70020ef2e0d063e5$var$load("ffQaD"),
    $70020ef2e0d063e5$var$load("kvRbA"),
    $70020ef2e0d063e5$var$load("fliVL"),
    $70020ef2e0d063e5$var$load("6rSuF")
]).then(()=>parcelRequire('dfMo9'));

});


parcelRegister("9KhHm", function(module, exports) {

$parcel$export(module.exports, "VotedIssuesGadgetEdit", () => $0ca7bf6a0d6f5346$export$7650b85a7a54914);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2VZar")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/voted-issues/edit/main.tsx"
});
const $0ca7bf6a0d6f5346$export$7650b85a7a54914 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "voted-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit, props));
const { preload: $0ca7bf6a0d6f5346$export$513ccb98c53b8039 } = $0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit;

});
parcelRegister("2VZar", function(module, exports) {

let $22305a35fb2413e0$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $22305a35fb2413e0$var$load("czifk"),
            $22305a35fb2413e0$var$load("l253H"),
            $22305a35fb2413e0$var$load("76n7a"),
            $22305a35fb2413e0$var$load("kvRbA"),
            $22305a35fb2413e0$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $22305a35fb2413e0$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $22305a35fb2413e0$var$load("cTJTG"),
            $22305a35fb2413e0$var$load("l253H"),
            $22305a35fb2413e0$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $22305a35fb2413e0$var$load("4Qxp7")
        ]);
    }),
    $22305a35fb2413e0$var$load("kNFvF"),
    $22305a35fb2413e0$var$load("ffQaD"),
    $22305a35fb2413e0$var$load("kvRbA"),
    $22305a35fb2413e0$var$load("fliVL"),
    $22305a35fb2413e0$var$load("eDCzE")
]).then(()=>parcelRequire('irHWu'));

});


parcelRegister("5ALJk", function(module, exports) {

$parcel$export(module.exports, "WatchedIssuesGadgetEdit", () => $278dbe55a7acf378$export$a53864bd0bf8a85f);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("as8kL")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/watched-issues/edit/main.tsx"
});
const $278dbe55a7acf378$export$a53864bd0bf8a85f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "watched-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit, props));
const { preload: $278dbe55a7acf378$export$513ccb98c53b8039 } = $278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit;

});
parcelRegister("as8kL", function(module, exports) {

let $79c2fbd5f393d944$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $79c2fbd5f393d944$var$load("czifk"),
            $79c2fbd5f393d944$var$load("l253H"),
            $79c2fbd5f393d944$var$load("76n7a"),
            $79c2fbd5f393d944$var$load("kvRbA"),
            $79c2fbd5f393d944$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $79c2fbd5f393d944$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $79c2fbd5f393d944$var$load("cTJTG"),
            $79c2fbd5f393d944$var$load("l253H"),
            $79c2fbd5f393d944$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $79c2fbd5f393d944$var$load("4Qxp7")
        ]);
    }),
    $79c2fbd5f393d944$var$load("kNFvF"),
    $79c2fbd5f393d944$var$load("ffQaD"),
    $79c2fbd5f393d944$var$load("kvRbA"),
    $79c2fbd5f393d944$var$load("fliVL"),
    $79c2fbd5f393d944$var$load("6LqWP")
]).then(()=>parcelRequire('iLll9'));

});


parcelRegister("hfHPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f27ae6f4005fc53$export$2e2bcd8739ae039);

var $fJpBG = parcelRequire("fJpBG");

var $lgZ6q = parcelRequire("lgZ6q");

var $8rq2P = parcelRequire("8rq2P");

var $jyMtv = parcelRequire("jyMtv");
const $9f27ae6f4005fc53$var$createGetInitialState = ({ predeterminedJql: predeterminedJql, predeterminedJqlIncludeResolved: predeterminedJqlIncludeResolved, defaultSortPrefs: defaultSortPrefs, testId: testId })=>async (resourceContext, userPrefs)=>{
        if (resourceContext?.tenantContext == null) throw new Error('Tenant context is not available');
        const { cloudId: cloudId, activationId: activationId } = resourceContext.tenantContext;
        const validUserPrefs = (0, $jyMtv.transformToValidUserPrefs)((0, $fJpBG.decodeUserPreferences)(userPrefs));
        if (validUserPrefs.filterId === undefined && predeterminedJql === undefined && predeterminedJqlIncludeResolved === undefined) throw new Error('FilterId or JQL has to be available to be able to load the gadget initial state');
        const sortPrefs = (()=>{
            if (validUserPrefs.sortField) return {
                sortField: validUserPrefs.sortField,
                sortDirection: validUserPrefs.sortDirection
            };
            if (defaultSortPrefs) return {
                sortField: defaultSortPrefs.field,
                sortDirection: defaultSortPrefs.direction
            };
        })();
        const includeResolved = validUserPrefs.showResolved;
        const jql = includeResolved ? predeterminedJqlIncludeResolved : predeterminedJql;
        const queryReference = await (0, $8rq2P.loadQueryWithUserPrefs)({
            ...validUserPrefs,
            ...sortPrefs
        }, (0, $lgZ6q.default), cloudId, activationId, 'store-and-network', jql);
        return {
            queryReference: queryReference,
            predeterminedJql: predeterminedJql,
            defaultSortPrefs: defaultSortPrefs,
            testId: testId
        };
    };
var $9f27ae6f4005fc53$export$2e2bcd8739ae039 = $9f27ae6f4005fc53$var$createGetInitialState;

});
parcelRegister("fJpBG", function(module, exports) {

$parcel$export(module.exports, "getUserPreferences", () => $a6145919a3771254$export$ae3f5fa351e2f57a);
$parcel$export(module.exports, "decodeUserPreferences", () => $a6145919a3771254$export$ebdfc6c2778ef8e2);

var $7f4tk = parcelRequire("7f4tk");
const $a6145919a3771254$var$isBooleanString = (str)=>[
        'true',
        'false'
    ].includes(str.toLowerCase().trim());
const $a6145919a3771254$var$stringToBoolean = (str)=>str.toLowerCase().trim() === 'true';
const $a6145919a3771254$export$ae3f5fa351e2f57a = (action)=>(0, $7f4tk.default)(action);
const $a6145919a3771254$export$ebdfc6c2778ef8e2 = (userPreferences = [])=>userPreferences.reduce((output, { value: value, name: name })=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...output,
            [name]: $a6145919a3771254$var$isBooleanString(value) ? $a6145919a3771254$var$stringToBoolean(value) : value
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});

});

parcelRegister("lgZ6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $328d775330990290$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c4e31a68119351cef8323a72a5f2950e>>
 * @relayHash fea1f7f8d2cc4709576d4f7f8bf90996
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fea613d296016cf3a3afa315fc9c13b7ef56403d42a84ecaebf814c9237cf2b3

var $5oQtH = parcelRequire("5oQtH");

var $5ykrX = parcelRequire("5ykrX");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $328d775330990290$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNotFilterFetch"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v14 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v21 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            v19 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v21 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v23 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v25 = {
        "kind": "Variable",
        "name": "fieldSetIds",
        "variableName": "fieldSetIds"
    }, v26 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v27 = {
        "kind": "ScalarField",
        "name": "type"
    }, v28 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v29 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v30 = {
        "kind": "ScalarField",
        "name": "name"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v30 /*: any*/ ,
                                    v17 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v32 = {
        "kind": "ScalarField",
        "name": "value"
    }, v33 = [
        v32 /*: any*/ ,
        v17 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v34 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v35 = {
        "kind": "ClientExtension",
        "selections": [
            v34 /*: any*/ 
        ]
    }, v36 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v37 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v38 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v39 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v40 = {
        "kind": "ScalarField",
        "name": "text"
    }, v41 = {
        "kind": "InlineFragment",
        "selections": [
            v40 /*: any*/ ,
            v30 /*: any*/ ,
            v35 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v42 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v43 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v17 /*: any*/ 
        ]
    }, v44 = [
        v43 /*: any*/ 
    ], v45 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v46 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v32 /*: any*/ 
        ]
    }, v47 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v48 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v49 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v50 = {
        "kind": "ClientExtension",
        "selections": [
            v24 /*: any*/ 
        ]
    }, v51 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraCascadingOption",
                        "kind": "LinkedField",
                        "name": "cascadingOption",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "parentOptionValue",
                                "plural": false,
                                "selections": v33 /*: any*/ 
                            },
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "childOptionValue",
                                "plural": false,
                                "selections": v33 /*: any*/ 
                            }
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraCascadingSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "args": v36 /*: any*/ ,
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v37 /*: any*/ ,
                                            v38 /*: any*/ ,
                                            v17 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedComponentsConnection(first:1000)"
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v39 /*: any*/ ,
                    v30 /*: any*/ ,
                    v35 /*: any*/ 
                ],
                "type": "JiraDateTimePickerField"
            },
            v41 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraCommentSummary",
                        "kind": "LinkedField",
                        "name": "commentSummary",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "canAddComment"
                            },
                            v42 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraCommentSummaryField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "uri"
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraUrlField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "fieldOptions",
                        "plural": false,
                        "selections": [
                            v42 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "fieldOption",
                        "plural": false,
                        "selections": [
                            v32 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v44 /*: any*/ 
                            },
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v44 /*: any*/ 
                            },
                            v17 /*: any*/ ,
                            v45 /*: any*/ 
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraSingleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v17 /*: any*/ ,
                                            v32 /*: any*/ ,
                                            v45 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraMultipleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    v46 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraCheckboxesField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraUserConnection",
                        "kind": "LinkedField",
                        "name": "selectedUsersConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v18 /*: any*/ ,
                                            v47 /*: any*/ ,
                                            v30 /*: any*/ ,
                                            v48 /*: any*/ ,
                                            v17 /*: any*/ ,
                                            v49 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "email"
                                                    }
                                                ],
                                                "type": "AtlassianAccountUser"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraMultipleSelectUserPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraTeamView",
                        "kind": "LinkedField",
                        "name": "selectedTeam",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedName"
                            }
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraTeamViewField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v17 /*: any*/ ,
                                    {
                                        "concreteType": "JiraEstimate",
                                        "kind": "LinkedField",
                                        "name": "originalEstimate",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "timeInSeconds"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraTimeTrackingSettings",
                                        "kind": "LinkedField",
                                        "name": "timeTrackingSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingHoursPerDay"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingDaysPerWeek"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultFormat"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultUnit"
                                            }
                                        ]
                                    },
                                    v19 /*: any*/ ,
                                    v30 /*: any*/ ,
                                    v27 /*: any*/ ,
                                    v35 /*: any*/ 
                                ]
                            },
                            v17 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraOriginalTimeEstimateField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "selectedOption",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "label",
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            v17 /*: any*/ ,
                            v37 /*: any*/ 
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraRadioSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "args": v36 /*: any*/ ,
                        "concreteType": "JiraVersionConnection",
                        "kind": "LinkedField",
                        "name": "selectedVersionsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraVersionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v17 /*: any*/ ,
                                            v30 /*: any*/ ,
                                            v37 /*: any*/ ,
                                            v38 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "versionId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedVersionsConnection(first:1000)"
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraMultipleVersionPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ 
                        ]
                    },
                    {
                        "args": v36 /*: any*/ ,
                        "concreteType": "JiraGoalConnection",
                        "kind": "LinkedField",
                        "name": "selectedGoals",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v17 /*: any*/ ,
                                            v15 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            v50 /*: any*/ 
                        ],
                        "storageKey": "selectedGoals(first:1000)"
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            v24 /*: any*/ ,
                            v34 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraGoalsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "args": v36 /*: any*/ ,
                        "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                        "kind": "LinkedField",
                        "name": "confluenceRemoteIssueLinks",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v17 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "href"
                                            }
                                        ]
                                    }
                                ]
                            },
                            v42 /*: any*/ 
                        ],
                        "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraConfluenceRemoteIssueLinksField"
            }
        ]
    }, v52 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v53 = [
        v30 /*: any*/ ,
        v17 /*: any*/ 
    ], v54 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "componentsOld",
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": v53 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v40 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v55 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v56 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v30 /*: any*/ ,
            v55 /*: any*/ ,
            v35 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v57 = {
        "kind": "InlineFragment",
        "selections": [
            v39 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v58 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "summary"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v59 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v60 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v20 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v61 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v21 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v62 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v36 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v30 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v42 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v30 /*: any*/ ,
            v35 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "small"
                            }
                        ]
                    },
                    v30 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v64 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v65 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v43 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v66 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v67 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v66 /*: any*/ ,
                    v30 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            },
            v17 /*: any*/ 
        ]
    }, v68 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v69 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v64 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v15 /*: any*/ ,
                            v65 /*: any*/ ,
                            v67 /*: any*/ ,
                            v64 /*: any*/ ,
                            v17 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v15 /*: any*/ ,
                            v65 /*: any*/ ,
                            v67 /*: any*/ ,
                            v64 /*: any*/ ,
                            v17 /*: any*/ ,
                            v16 /*: any*/ ,
                            v68 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "summary",
                                            "issuetype",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v18 /*: any*/ ,
                                                    v17 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v19 /*: any*/ ,
                                                            v40 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v19 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    },
                                                                    v30 /*: any*/ ,
                                                                    v66 /*: any*/ ,
                                                                    v23 /*: any*/ ,
                                                                    v17 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v22 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                            }
                        ]
                    },
                    v30 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v70 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    v17 /*: any*/ 
                ]
            },
            v30 /*: any*/ ,
            v35 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v71 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v15 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v72 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v53 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v73 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v17 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v30 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v30 /*: any*/ ,
            v35 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v74 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v18 /*: any*/ ,
                    v47 /*: any*/ ,
                    v48 /*: any*/ ,
                    v30 /*: any*/ ,
                    v17 /*: any*/ ,
                    v49 /*: any*/ 
                ]
            },
            v30 /*: any*/ ,
            v55 /*: any*/ ,
            v35 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v75 = {
        "kind": "InlineFragment",
        "selections": [
            v30 /*: any*/ ,
            {
                "args": v36 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v53 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v76 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "json"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v77 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v66 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v78 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v68 /*: any*/ ,
                                            v15 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v18 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v21 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v17 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v17 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v17 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v79 = {
        "kind": "ScalarField",
        "name": "number"
    }, v80 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v79 /*: any*/ ,
            v30 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    v79 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v79 /*: any*/ ,
                    v30 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            },
            v35 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v81 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraGroupConnection",
                        "kind": "LinkedField",
                        "name": "selectedGroupsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGroupEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGroup",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v17 /*: any*/ ,
                                            v30 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "groupId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraMultipleGroupPickerField"
            }
        ]
    }, v82 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraFlag",
                        "kind": "LinkedField",
                        "name": "flag",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFlagged"
                            }
                        ]
                    }
                ],
                "type": "JiraFlagField"
            }
        ]
    }, v83 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraWatch",
                        "kind": "LinkedField",
                        "name": "watch",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            }
                        ]
                    }
                ],
                "type": "JiraWatchesField"
            }
        ]
    }, v84 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v27 /*: any*/ ,
                        v28 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v51 /*: any*/ ,
                                                v52 /*: any*/ ,
                                                v54 /*: any*/ ,
                                                v56 /*: any*/ ,
                                                v57 /*: any*/ ,
                                                v58 /*: any*/ ,
                                                v59 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v60 /*: any*/ ,
                                                v61 /*: any*/ ,
                                                v62 /*: any*/ ,
                                                v63 /*: any*/ ,
                                                v69 /*: any*/ ,
                                                v70 /*: any*/ ,
                                                v71 /*: any*/ ,
                                                v72 /*: any*/ ,
                                                v73 /*: any*/ ,
                                                v74 /*: any*/ ,
                                                v75 /*: any*/ ,
                                                v76 /*: any*/ ,
                                                v77 /*: any*/ ,
                                                v78 /*: any*/ ,
                                                v80 /*: any*/ ,
                                                v81 /*: any*/ ,
                                                v82 /*: any*/ ,
                                                v83 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v85 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v86 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ], v87 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueTableViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issueTableView_reactIssueTableGadgets"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v12 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ ,
                v9 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueTableViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetsInput",
                                    "variableName": "fieldSetsInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isResolved"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "status"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v18 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"status\"])"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canBeExported"
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        v25 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsById",
                                                                    "plural": false,
                                                                    "selections": v84 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "context",
                                                                            "variableName": "fieldSetsContext"
                                                                        },
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "filterId",
                                                                            "variableName": "filterId"
                                                                        },
                                                                        v26 /*: any*/ ,
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "namespace",
                                                                            "variableName": "namespace"
                                                                        },
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "viewId",
                                                                            "variableName": "viewId"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsForIssueSearchView",
                                                                    "plural": false,
                                                                    "selections": v84 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v18 /*: any*/ ,
                                        v50 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 500
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v29 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v31 /*: any*/ ,
                                                                                                v51 /*: any*/ ,
                                                                                                v52 /*: any*/ ,
                                                                                                v54 /*: any*/ ,
                                                                                                v56 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v58 /*: any*/ ,
                                                                                                v59 /*: any*/ ,
                                                                                                v41 /*: any*/ ,
                                                                                                v60 /*: any*/ ,
                                                                                                v61 /*: any*/ ,
                                                                                                v62 /*: any*/ ,
                                                                                                v63 /*: any*/ ,
                                                                                                v69 /*: any*/ ,
                                                                                                v70 /*: any*/ ,
                                                                                                v71 /*: any*/ ,
                                                                                                v72 /*: any*/ ,
                                                                                                v73 /*: any*/ ,
                                                                                                v74 /*: any*/ ,
                                                                                                v75 /*: any*/ ,
                                                                                                v76 /*: any*/ ,
                                                                                                v77 /*: any*/ ,
                                                                                                v78 /*: any*/ ,
                                                                                                v80 /*: any*/ ,
                                                                                                v81 /*: any*/ ,
                                                                                                v82 /*: any*/ ,
                                                                                                v83 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v46 /*: any*/ ,
                                                                                                                        v50 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v45 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v85 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "pageSize",
                                            "variableName": "first"
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": v86 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": v86 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": v86 /*: any*/ 
                                        }
                                    ]
                                },
                                v50 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v14 /*: any*/ ,
                                v25 /*: any*/ 
                            ],
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v87 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jqlTerm"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isSortable"
                                                },
                                                {
                                                    "concreteType": "JiraFieldSetPreferences",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetPreferences",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "width"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isPlaceHolderField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraFieldType",
                                                    "kind": "LinkedField",
                                                    "name": "fieldType",
                                                    "plural": false,
                                                    "selections": [
                                                        v87 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v42 /*: any*/ ,
                                v50 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "isNotFilterFetch",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v85 /*: any*/ ,
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fea613d296016cf3a3afa315fc9c13b7ef56403d42a84ecaebf814c9237cf2b3",
            "metadata": {},
            "name": "issueTableViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$328d775330990290$var$node.hash = "b9be546215dff0bc5951b61ed28bf1f5";
var $328d775330990290$export$2e2bcd8739ae039 = $328d775330990290$var$node;

});

parcelRegister("8rq2P", function(module, exports) {

$parcel$export(module.exports, "loadQueryWithUserPrefs", () => $3de2b9db429d32f1$export$700e212b8b5c678f);

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $2mSjU = parcelRequire("2mSjU");
async function $3de2b9db429d32f1$export$700e212b8b5c678f({ filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection }, query, cloudId, activationId, fetchPolicy = 'store-or-network', jql) {
    const { variables: variables } = await (0, $2mSjU.transformToVariables)({
        userPrefs: {
            filterId: filterId,
            columnNames: columnNames,
            num: num,
            sortField: sortField,
            sortDirection: sortDirection
        },
        cloudId: cloudId,
        activationId: activationId,
        jql: jql
    });
    const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), query, variables, {
        fetchPolicy: fetchPolicy
    });
    if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
    return queryReference;
}

});
parcelRegister("2mSjU", function(module, exports) {

$parcel$export(module.exports, "transformToVariables", () => $1eea58ad38e5fdd1$export$a5cefa50115212b3);

var $gbLWS = parcelRequire("gbLWS");

var $6s1PB = parcelRequire("6s1PB");

var $czfFt = parcelRequire("czfFt");

var $t3Q07 = parcelRequire("t3Q07");

var $796ok = parcelRequire("796ok");



const $1eea58ad38e5fdd1$export$a5cefa50115212b3 = async ({ userPrefs: userPrefs, cloudId: cloudId, activationId: activationId, jql: jql, fetchIssueTableJqlFields: fetchIssueTableJqlFields })=>{
    const { filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection, showResolved: showResolved } = userPrefs;
    const filterAri = !jql && filterId ? (0, $gbLWS.JiraFilterAri).create({
        filterId: filterId,
        siteId: cloudId,
        activationId: activationId
    }).toString() : '';
    const variables = {
        cloudId: cloudId,
        issueSearchInput: {
            ...jql ? {
                jql: jql
            } : {
                filterId: filterId
            }
        },
        after: null,
        first: num,
        fieldSetIds: columnNames,
        amountOfColumns: (0, $czfFt.MAX_COLUMNS),
        shouldQueryFieldSetsById: true,
        fieldSetsInput: (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? {
            fieldSetIds: columnNames
        } : null,
        isNotFilterFetch: !filterAri,
        filterAri: filterAri
    };
    let fieldToJqlTermMap = new Map();
    if (!sortField || !sortDirection || ![
        'ASC',
        'DESC'
    ].includes(sortDirection)) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    let jqlToModify = jql;
    if (fetchIssueTableJqlFields && !jqlToModify && filterAri) {
        const result = await fetchIssueTableJqlFields(filterAri, variables.fieldSetIds, cloudId);
        fieldToJqlTermMap = result.fieldToJqlTermMap;
        jqlToModify = result.searchJql;
    }
    if (!jqlToModify) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    // This pulls in over 600KB of code, and if it's not deferred it's eagerly loaded as
    // part of the main jira-spa route map
    const [{ JqlUtils: JqlUtils }, { default: removeFieldClauseFromJql }, { default: findClauseInAst }] = await Promise.all([
        (parcelRequire("lEsjw")),
        (parcelRequire("60ZTe")),
        (parcelRequire("j4Vmz"))
    ]);
    const jqlUtils = new JqlUtils();
    const jqlTermForSortField = (0, $796ok.getJqlTermForField)(sortField, fieldToJqlTermMap);
    const modifiedJql = jqlUtils.jql(jqlToModify);
    const oldPrimarySortField = modifiedJql.getPrimarySortField();
    if (oldPrimarySortField) {
        // if the sort field in original filter jql is using alias, we need to pass all possible aliases in
        // so that jqlUtils knows to replace it instead of append it as a new field
        const aliases = (0, $t3Q07.getAliasesForField)(jqlTermForSortField, fieldToJqlTermMap);
        // Sometimes, oldPrimarySortField from the JQL has
        // quotations around it which we should include
        const inclusiveAliases = Array.from(new Set([
            ...aliases,
            oldPrimarySortField
        ]));
        modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, inclusiveAliases);
    } else modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, []);
    let finalJql = modifiedJql.jqlString;
    if (showResolved) {
        const jast = modifiedJql.jast;
        if (jast) {
            const statusClause = findClauseInAst(jast, 'statusCategory');
            if (statusClause) finalJql = removeFieldClauseFromJql(jast, statusClause);
        }
    }
    return {
        variables: {
            ...variables,
            issueSearchInput: {
                jql: finalJql
            }
        },
        fieldToJqlTermMap: fieldToJqlTermMap
    };
};

});
parcelRegister("t3Q07", function(module, exports) {

$parcel$export(module.exports, "getAliasesForField", () => $a3816529ae558e1d$export$94d69942fbe58a01);
const $a3816529ae558e1d$export$94d69942fbe58a01 = (field, fieldToJqlTermMap)=>{
    // provided field could be a field id, name, an alias, or a jql term
    let term = fieldToJqlTermMap.get(field);
    if (term === undefined) {
        // it may be a jql term itself
        // filter is still an experiment feature in Iterator so we do old school looping
        for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === field) {
            term = keyValuePair[1];
            break;
        }
    }
    if (term === undefined) return [];
    // we do a reverse look-up to find any other keys of this jql term, they can all be used in a jql
    const set = new Set();
    set.add(term);
    for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === term) set.add(keyValuePair[0]);
    return Array.from(set);
};

});

parcelRegister("796ok", function(module, exports) {

$parcel$export(module.exports, "getJqlTermForField", () => $ad837b869bddcad8$export$ef4e8b2c9bc7bd4d);

var $bCU3R = parcelRequire("bCU3R");
const $ad837b869bddcad8$export$ef4e8b2c9bc7bd4d = (field, fieldToJqlTermMap)=>{
    const convertedField = (0, $bCU3R.convertFieldToJqlTerm)(field);
    const jqlTermForField = fieldToJqlTermMap.get(convertedField) ?? convertedField;
    return jqlTermForField;
};

});
parcelRegister("bCU3R", function(module, exports) {

$parcel$export(module.exports, "convertFieldToJqlTerm", () => $1e1011370a3a12e2$export$29f734dc2c61ea9d);
const $1e1011370a3a12e2$export$29f734dc2c61ea9d = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    // fieldName match regex for customfield_<number> exactly
    // legacy gadget may have it stored as customfield_<number> in user prefs
    if (/^customfield_\d+$/.test(fieldName)) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    return fieldName;
};

});


parcelRegister("lEsjw", function(module, exports) {

let $fc334bf5644f80c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc334bf5644f80c4$var$load("i8Zoh").then(()=>parcelRequire('aWG9Z'));

});

parcelRegister("60ZTe", function(module, exports) {

let $4612c03314737910$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4612c03314737910$var$load("4EmhV").then(()=>parcelRequire('eWn4R'));

});

parcelRegister("j4Vmz", function(module, exports) {

let $de3ae31f5334659f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de3ae31f5334659f$var$load("fEFRC").then(()=>parcelRequire('ajrrh'));

});



parcelRegister("jyMtv", function(module, exports) {

$parcel$export(module.exports, "transformToValidUserPrefs", () => $8cfaebab7e294873$export$e9345b021afd3cc3);

var $hwva3 = parcelRequire("hwva3");

var $Z4X9T = parcelRequire("Z4X9T");

var $hCluT = parcelRequire("hCluT");
const $8cfaebab7e294873$export$e9345b021afd3cc3 = (rawUserPrefs)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const pageSize = parseInt(rawUserPrefs.num, 10);
    const fieldSetIds = (0, $hwva3.convertUserPrefsToColumnNames)(rawUserPrefs.columnNames);
    const stringifiedFilterId = `${rawUserPrefs.filterId}`;
    const { sortDirection: sortDirection, sortField: sortField } = (0, $Z4X9T.getSortFieldAndDirection)(rawUserPrefs.sortBy);
    const showResolved = !!rawUserPrefs.showResolved;
    return {
        filterId: (0, $hCluT.isFilterId)(stringifiedFilterId) ? stringifiedFilterId : undefined,
        columnNames: fieldSetIds,
        num: !Number.isNaN(pageSize) ? pageSize : 10,
        sortDirection: sortDirection,
        sortField: sortField,
        showResolved: showResolved
    };
};

});
parcelRegister("hwva3", function(module, exports) {

$parcel$export(module.exports, "convertUserPrefsToColumnNames", () => $ffa5f3be2fc11704$export$6e5cdc232ebb20cf);

var $JIPqS = parcelRequire("JIPqS");

const $ffa5f3be2fc11704$export$6e5cdc232ebb20cf = (columns)=>typeof columns === 'string' && columns !== '' && columns !== '--Default--' ? columns.split((0, $e997f85ca70fa8bf$export$a3d4af30107c4f4d)).map((col)=>col.replaceAll((0, $e997f85ca70fa8bf$export$952287cc7aef3a4c), (0, $e997f85ca70fa8bf$export$a3d4af30107c4f4d))) : (0, $JIPqS.ISSUE_SEARCH_DEFAULT_COLUMNS);

});
const $e997f85ca70fa8bf$export$dd03181e30c7d559 = 5;
const $e997f85ca70fa8bf$export$a3d4af30107c4f4d = '|';
const $e997f85ca70fa8bf$export$952287cc7aef3a4c = '%7C';


parcelRegister("Z4X9T", function(module, exports) {

$parcel$export(module.exports, "getSortFieldAndDirection", () => $834bd6f85e4a1e0d$export$e535bb2dfaa4d10b);
const $834bd6f85e4a1e0d$export$e535bb2dfaa4d10b = (sortByFromUserPrefs)=>{
    const [sortField, sortDirection] = typeof sortByFromUserPrefs === 'string' ? sortByFromUserPrefs.split(':') : [];
    if (!sortField || sortDirection !== 'ASC' && sortDirection !== 'DESC') return {};
    return {
        sortField: sortField,
        sortDirection: sortDirection
    };
};

});

parcelRegister("hCluT", function(module, exports) {

$parcel$export(module.exports, "isFilterId", () => $39fbd6b125bd3cbf$export$23be85030bd58047);
// this is copied from NIN https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/issue-navigator/actions/common/src/utils/filters/index.tsx?at=abdc1df97c8cee2475285ab25c47a938ce99d65a
const $39fbd6b125bd3cbf$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});




parcelRegister("26UOd", function(module, exports) {

$parcel$export(module.exports, "REACT_KEY", () => $c373d1a6bf5d7ef6$export$e0e89108956f58f6);
// React gadget keys
const $c373d1a6bf5d7ef6$export$c8ae0b83405368ed = 'react/filter-results';
const $c373d1a6bf5d7ef6$var$REACT_KEY_ASSIGNED_TO_ME = 'react/assigned-to-me';
const $c373d1a6bf5d7ef6$var$REACT_KEY_ISSUES_IN_PROGRESS = 'react/issues-in-progress';
const $c373d1a6bf5d7ef6$var$REACT_KEY_VOTED_ISSUES = 'react/voted-issues';
const $c373d1a6bf5d7ef6$var$REACT_KEY_WATCHED_ISSUES = 'react/watched-issues';
const $c373d1a6bf5d7ef6$var$REACT_KEY_CUSTOM_REPORT = 'react/custom-report';
const $c373d1a6bf5d7ef6$export$e0e89108956f58f6 = {
    FILTER_RESULTS: $c373d1a6bf5d7ef6$export$c8ae0b83405368ed,
    ASSIGNED_TO_ME: $c373d1a6bf5d7ef6$var$REACT_KEY_ASSIGNED_TO_ME,
    ISSUES_IN_PROGRESS: $c373d1a6bf5d7ef6$var$REACT_KEY_ISSUES_IN_PROGRESS,
    VOTED_ISSUES: $c373d1a6bf5d7ef6$var$REACT_KEY_VOTED_ISSUES,
    WATCHED_ISSUES: $c373d1a6bf5d7ef6$var$REACT_KEY_WATCHED_ISSUES,
    CUSTOM_REPORT: $c373d1a6bf5d7ef6$var$REACT_KEY_CUSTOM_REPORT
};

});




parcelRegister("aVFmC", function(module, exports) {

$parcel$export(module.exports, "default", () => $31463ce0406b73cb$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31463ce0406b73cb$export$2e2bcd8739ae039 = async ()=>(0, $eusud.performGetRequest)('/rest/config/1.0/directoryitems.json');

});

parcelRegister("3Zhqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c788e303134293$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $5IKQ6 = parcelRequire("5IKQ6");

var $kspzT = parcelRequire("kspzT");

var $3Yd87 = parcelRequire("3Yd87");

var $kGR9w = parcelRequire("kGR9w");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b1c788e303134293$export$2e2bcd8739ae039 = (maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch }, spaContext)=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $3Yd87.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { reactGadgets: nextGadgets } = sharedValue;
            const prev = maybePrevData != null && !(maybePrevData instanceof Error) && maybePrevData.reactGadgetsState || {};
            const persistedGadgets = nextGadgets.filter(({ id: id })=>!!prev[id]);
            const gadgetsToLoad = nextGadgets.filter((gadget)=>{
                // componentEdit will be optional in the future, although currently types say that it's required
                const isConfigurable = !!(0, $kspzT.default)[gadget.reactKey].componentEdit;
                const isUnconfigured = isConfigurable && !(0, $5IKQ6.isGadgetConfigured)(gadget.userPrefs);
                return !prev[gadget.id] && !isUnconfigured;
            });
            const skippedGadgets = nextGadgets.filter((gadget)=>!prev[gadget.id] && !gadgetsToLoad.some(({ id: id })=>id === gadget.id));
            const reactGadgetsState = {
                ...Object.fromEntries(persistedGadgets.map(({ id: id })=>[
                        id,
                        prev[id]
                    ])),
                ...Object.fromEntries(skippedGadgets.map(({ id: id })=>[
                        id,
                        {}
                    ])),
                ...await (0, $kGR9w.loadReactGadgets)(gadgetsToLoad, spaContext)
            };
            return {
                sharedValue: sharedValue,
                reactGadgetsState: reactGadgetsState
            };
        })();
    };

});
parcelRegister("5IKQ6", function(module, exports) {

$parcel$export(module.exports, "isGadgetConfigured", () => $ce7e823be599a5b0$export$b625fae487818738);
const $ce7e823be599a5b0$export$b625fae487818738 = (userPrefs)=>userPrefs?.fields.some(({ name: name, value: value })=>name === 'isConfigured' && value === 'true') ?? false;

});

parcelRegister("kGR9w", function(module, exports) {

$parcel$export(module.exports, "loadReactGadgets", () => $ae0204181dcaff49$export$7e1a3455761184a2);
// eslint-disable-next-line jira/import-whitelist

var $kspzT = parcelRequire("kspzT");
const $ae0204181dcaff49$var$preloadGadgetBundles = (reactKeys)=>reactKeys.forEach((reactKey)=>{
        (0, $kspzT.default)[reactKey].preload();
    });
const $ae0204181dcaff49$export$7e1a3455761184a2 = async (gadgets, spaContext)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const distinctReactKeys = [
        ...new Set(gadgets.map((gadget)=>gadget.reactKey))
    ];
    $ae0204181dcaff49$var$preloadGadgetBundles(distinctReactKeys);
    return Object.fromEntries(await Promise.all(gadgets.map(({ id: id, reactKey: reactKey, userPrefs: userPrefs })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $kspzT.default)[reactKey]?.getInitialState(spaContext, userPrefs?.fields || []).then((state)=>[
                id,
                state
            ], (error)=>[
                id,
                error
            ]))));
};

});




parcelRegister("aAXPH", function(module, exports) {

$parcel$export(module.exports, "ExportIssuesState", () => $c5ed520d0058f822$export$3a9cf28c88b7cf7e);
$parcel$export(module.exports, "useExportIssuesState", () => $c5ed520d0058f822$export$47252c65caeadab5);
$parcel$export(module.exports, "useExportIssuesStateActions", () => $c5ed520d0058f822$export$102e03cf49b1438f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $c5ed520d0058f822$var$actions = {
    addExportInProgress: ({ exportName: exportName, flagId: flagId, commonInput: commonInput })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                exportsInProgress: new Map([
                    ...state.exportsInProgress,
                    [
                        exportName,
                        {
                            flagId: flagId,
                            commonInput: commonInput
                        }
                    ]
                ])
            });
        },
    removeExportInProgress: (exportName)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const exportsInProgress = new Map(state.exportsInProgress);
            exportsInProgress.delete(exportName);
            setState({
                exportsInProgress: exportsInProgress
            });
        }
};
const $c5ed520d0058f822$var$store = (0, $iXqE5.createStore)({
    initialState: {
        exportsInProgress: new Map()
    },
    actions: $c5ed520d0058f822$var$actions
});
const $c5ed520d0058f822$export$3a9cf28c88b7cf7e = (0, $gg7kZ.createContainer)($c5ed520d0058f822$var$store, {});
const $c5ed520d0058f822$export$47252c65caeadab5 = (0, $3sQ5x.createHook)($c5ed520d0058f822$var$store);
const $c5ed520d0058f822$export$102e03cf49b1438f = (0, $3sQ5x.createActionsHook)($c5ed520d0058f822$var$store);

});

const $f1cf4dfa4ee555bb$export$1e7e0a89f0a63194 = 'charts';
const $f1cf4dfa4ee555bb$export$7210f66fc3ef484b = 'currentCsvFields';
const $f1cf4dfa4ee555bb$export$dd2785a26fde4088 = 'currentCsvWithBomFields';
const $f1cf4dfa4ee555bb$export$252cadaf3f37581d = 'currentExcelFields';
const $f1cf4dfa4ee555bb$export$9ec42030ff590bf5 = 'printable';
const $f1cf4dfa4ee555bb$export$67fca8a214a30375 = 'printdetails';
const $f1cf4dfa4ee555bb$export$c7396bc6e39c9c11 = 'xml';
const $f1cf4dfa4ee555bb$export$5781d541cbf49b12 = 'rssIssues';
const $f1cf4dfa4ee555bb$export$a2c2ac37e6fdbf31 = 'rssComments';
const $f1cf4dfa4ee555bb$export$23d8995d755a4cf8 = 'word';
const $f1cf4dfa4ee555bb$export$b93937faf4abb2e = 'allExcelFields';
const $f1cf4dfa4ee555bb$export$3f70558bc632a391 = 'allCsvFields';
const $f1cf4dfa4ee555bb$export$9fb3f09d940736e9 = 'allCsvWithBomFields';

parcelRegister("bOHHa", function(module, exports) {

$parcel$export(module.exports, "useFetchAllExportIssuesResources", () => $58d7342d9e225e04$export$ed2bb36c6c9ec941);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $9Nvh7 = parcelRequire("9Nvh7");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $58d7342d9e225e04$export$dbcc369e613320e5 = '/rest/issueNav/1/issueNav/operations/views';
const $58d7342d9e225e04$export$dd48efeacda10f1a = (body)=>(0, $eusud.performPostRequest)($58d7342d9e225e04$export$dbcc369e613320e5, {
        credentials: 'same-origin',
        body: (0, $ebyGx.stringify)(body),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Atlassian-Token': 'no-check',
            __amdModuleName: 'jira/issue/utils/xsrf-token-header'
        }
    });
const $58d7342d9e225e04$export$ed2bb36c6c9ec941 = (jql, filterId, isFilterModified = false)=>{
    const [exportItems, setExportItems] = (0, $5uXOq.useState)();
    const [error, setError] = (0, $5uXOq.useState)();
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const lastUsedJqlRef = (0, $5uXOq.useRef)();
    const lastUsedFilterIdRef = (0, $5uXOq.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fetch = (0, $5uXOq.useCallback)(async (fetchRetry)=>{
        try {
            /** We don't want to refetch if the JQL and the filterID haven't changed.
				 * Our WRM resource doesn't depend on JQL however, asyncWRMRequire will
				 * not refetch a resource if it's already available.
				 */ if (jql !== lastUsedJqlRef.current || filterId !== lastUsedFilterIdRef.current) {
                setLoading(true);
                const exportItemsResponse = await $58d7342d9e225e04$export$dd48efeacda10f1a({
                    jql: jql,
                    getViewOptionHeader: true,
                    ...filterId != null && (0, $9Nvh7.isCustomFilter)(filterId) ? {
                        filterId: filterId
                    } : {},
                    ...isFilterModified ? {
                        modified: isFilterModified
                    } : {}
                });
                lastUsedJqlRef.current = jql;
                lastUsedFilterIdRef.current = filterId;
                setExportItems(exportItemsResponse);
                setError(undefined);
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    action: 'success',
                    actionSubject: 'fetchExportIssues'
                }), 'fetchExportIssues success', {
                    fetchRetry: fetchRetry
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('export-issues.useFetchAllExportIssuesResources', 'fetch resources', {
                shouldFetchExportIssuesResourcesOnClick: true,
                ...err
            });
            (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'fetchExportIssues',
                    packageName: 'jiraIssueNavigatorActionExportIssues',
                    teamName: 'empanada'
                },
                attributes: {
                    fetchRetry: fetchRetry
                }
            });
            setError(err);
        } finally{
            setLoading(false);
        }
    }, [
        createAnalyticsEvent,
        filterId,
        jql,
        isFilterModified
    ]);
    return {
        fetch: fetch,
        exportItems: exportItems,
        loading: loading,
        error: error
    };
};
var $58d7342d9e225e04$export$2e2bcd8739ae039 = $58d7342d9e225e04$export$ed2bb36c6c9ec941;

});

const $dcaffc959cbdbdf4$export$726b5607b2c3e51c = 3;

parcelRegister("8jWt2", function(module, exports) {

$parcel$export(module.exports, "ExportItem", () => $abeff5e10bce4d03$export$3718620ecf95d0b9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $6B7KL = parcelRequire("6B7KL");

var $1tcYS = parcelRequire("1tcYS");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $6s1PB = parcelRequire("6s1PB");

var $8mgvN = parcelRequire("8mgvN");

var $8CxS5 = parcelRequire("8CxS5");

var $etArH = parcelRequire("etArH");

var $aAXPH = parcelRequire("aAXPH");


var $80u5p = parcelRequire("80u5p");
const $abeff5e10bce4d03$var$menuItemStyles = null;
const $abeff5e10bce4d03$export$3718620ecf95d0b9 = ({ exportItem: exportItem, appCount: appCount, commonInput: commonInput, onOpenCreateDashboardGadgetModal: onOpenCreateDashboardGadgetModal })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const isAsync = (0, $8CxS5.isAsyncExportItem)(exportItem);
    const [{ exportsInProgress: exportsInProgress }, { addExportInProgress: addExportInProgress, removeExportInProgress: removeExportInProgress }] = (0, $aAXPH.useExportIssuesState)();
    const dashboardGadgetModalContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const dashboardGadgetModalInstrumentedHandler = (0, $5uXOq.useCallback)((event)=>{
        if (dashboardGadgetModalContext && dashboardGadgetModalContext.tracePress) dashboardGadgetModalContext.tracePress('create-dashboard-gadget-modal', event.timeStamp);
    }, [
        dashboardGadgetModalContext
    ]);
    const onClickDropDownItem = (0, $5uXOq.useCallback)((event)=>{
        if (isAsync) {
            const existingExportItem = exportsInProgress.get(exportItem.id);
            const flagId = existingExportItem?.flagId || (0, $7HGHK.toFlagId)((0, $7Jxgt.v4)()); /**
                                                                      * We only want one export per export type to be in progress at a time.
                                                                      */ 
            if (!existingExportItem) {
                showFlag({
                    id: flagId,
                    render: ({ key: key })=>{
                        return(/**
               * Flags are appended to the DOM in a different location than Export Issues button
               * so we need to wrap the ExportIssuesState using the same scope to ensure the state is shared
               */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aAXPH.ExportIssuesState), {
                            scope: "ExportIssuesState",
                            key: key
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                            attributes: {
                                exportId: exportItem.id,
                                exportLabel: exportItem.label,
                                exportType: exportItem.exportType,
                                maxResults: exportItem.maxResults
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80u5p.ExportIssuesTaskFlag), {
                            flagId: flagId,
                            exportItem: exportItem,
                            onDismissFlag: dismissFlag,
                            commonInput: commonInput
                        }))));
                    }
                });
                addExportInProgress({
                    exportName: exportItem.id,
                    flagId: flagId,
                    commonInput: commonInput
                });
            } else {
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'JiraIssueExportTask duplicated', {
                    sameInput: existingExportItem.commonInput === commonInput
                });
                const errorFlagId = `${flagId}-error`;
                showFlag({
                    type: 'error',
                    id: errorFlagId,
                    title: formatMessage((0, $8mgvN.default).exportIssuesAlreadyInProgressTitle, {
                        exportItemLabel: exportItem.label
                    }),
                    description: formatMessage((0, $8mgvN.default).exportIssuesAlreadyInProgressDescription),
                    messageId: 'issue-navigator-action-export-issues.ui.export-item.show-flag.error.export-issues-already-in-progress',
                    messageType: 'transactional',
                    actions: [
                        {
                            content: formatMessage((0, $8mgvN.default).exportIssuesAlreadyInProgressCancelExportAction),
                            onClick: ()=>{
                                removeExportInProgress(exportItem.id);
                                dismissFlag(flagId);
                                dismissFlag(errorFlagId);
                                const cancelEvent = createAnalyticsEvent({
                                    action: 'clicked',
                                    actionSubject: 'button'
                                });
                                (0, $8zOmE.fireUIAnalytics)(cancelEvent, 'cancelJiraIssueExportTask');
                            }
                        }
                    ]
                });
            }
        }
        if (exportItem.id === (0, $f1cf4dfa4ee555bb$export$1e7e0a89f0a63194)) {
            dashboardGadgetModalInstrumentedHandler(event);
            onOpenCreateDashboardGadgetModal();
        }
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dropdownItem clicked', 'export', {
            dropdownItem: exportItem.id ?? 'app',
            dropdownItemName: exportItem.label,
            appCount: appCount
        });
    }, [
        isAsync,
        exportItem,
        createAnalyticsEvent,
        appCount,
        exportsInProgress,
        showFlag,
        addExportInProgress,
        dismissFlag,
        commonInput,
        formatMessage,
        removeExportInProgress,
        dashboardGadgetModalInstrumentedHandler,
        onOpenCreateDashboardGadgetModal
    ]);
    const isLinkItem = exportItem.id !== (0, $f1cf4dfa4ee555bb$export$1e7e0a89f0a63194) && !isAsync;
    const isVREnabled = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons');
    const isHierarchyEnabled = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onClickDropDownItem,
        ...isLinkItem && {
            href: exportItem.link ?? '#',
            target: '_blank',
            rel: (0, $etArH.appendExportIssuesRelPolicy)(exportItem.rel)
        }
    }, isVREnabled && isHierarchyEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "issue-navigator-action-export-issues.ui.span",
        className: (0, $bwpsq.default)([
            "_ca0q12x7 _n3td12x7 _19bv1b66 _u5f31b66"
        ])
    }, exportItem.label) : // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": "issue-navigator-action-export-issues.ui.span"
    }, exportItem.label));
};

});
parcelRegister("8mgvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $efc5cf8e02604bac$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $efc5cf8e02604bac$var$messages = (0, $7VHMR.defineMessages)({
    exportIssuesAlreadyInProgressTitle: {
        "id": "issue-navigator-action-export-issues.common.export-issues-already-in-progress-title",
        "defaultMessage": "{exportItemLabel} already in progress"
    },
    exportIssuesAlreadyInProgressDescription: {
        "id": "issue-navigator-action-export-issues.common.export-issues-already-in-progress-description",
        "defaultMessage": "Wait for the export to complete, or cancel and start again."
    },
    exportIssuesAlreadyInProgressCancelExportAction: {
        "id": "issue-navigator-action-export-issues.common.export-issues-already-in-progress-cancel-export-action",
        "defaultMessage": "Cancel export"
    }
});
var $efc5cf8e02604bac$export$2e2bcd8739ae039 = $efc5cf8e02604bac$var$messages;

});

parcelRegister("80u5p", function(module, exports) {

$parcel$export(module.exports, "ExportIssuesTaskFlag", () => $e0bd4452728b6eba$export$a6b85b3f7c851bee);

var $lKTmd = parcelRequire("lKTmd");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $aAXPH = parcelRequire("aAXPH");

var $8tbGZ = parcelRequire("8tbGZ");

var $9cyMA = parcelRequire("9cyMA");

var $a8IjR = parcelRequire("a8IjR");

var $5ylu6 = parcelRequire("5ylu6");

var $itJjG = parcelRequire("itJjG");
const $e0bd4452728b6eba$export$a6b85b3f7c851bee = ({ exportItem: exportItem, onDismissFlag: onDismissFlagProp, flagId: flagId, commonInput: commonInput })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [exportIssuesTask, setExportIssuesTask] = (0, $5uXOq.useState)(null);
    const [error, setError] = (0, $5uXOq.useState)();
    const [downloadCompleted, setDownloadCompleted] = (0, $5uXOq.useState)(false);
    const { removeExportInProgress: removeExportInProgress } = (0, $aAXPH.useExportIssuesStateActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnDownloadComplete = (0, $5uXOq.useCallback)(()=>{
        setDownloadCompleted(true);
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'JiraIssueExportTask downloaded', {
            taskId: exportIssuesTask?.task?.id
        });
    }, [
        createAnalyticsEvent,
        exportIssuesTask?.task?.id
    ]);
    const onDismissFlag = (0, $5uXOq.useCallback)(()=>{
        removeExportInProgress(exportItem.id);
        onDismissFlagProp(flagId);
        /**
     * We don't want to fire the dismissed event if the download has completed because is autodismissed
     */ if (!downloadCompleted) {
            const cancelEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, $8zOmE.fireUIAnalytics)(cancelEvent, 'dismissedJiraIssueExportTask', {
                exportStatus: (0, $itJjG.getExportIssuesStatus)({
                    __typename: exportIssuesTask?.__typename,
                    downloadCompleted: downloadCompleted,
                    hasError: !!error
                })
            });
        }
    }, [
        createAnalyticsEvent,
        downloadCompleted,
        error,
        exportIssuesTask?.__typename,
        exportItem.id,
        flagId,
        onDismissFlagProp,
        removeExportInProgress
    ]);
    const handleOnNextSubscription = (0, $5uXOq.useCallback)((response)=>{
        setExportIssuesTask(response?.jira?.onIssueExported || null);
        if (response?.jira?.onIssueExported?.__typename === 'JiraIssueExportTaskCompleted') {
            removeExportInProgress(exportItem.id);
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'JiraIssueExportTask ExportSuccess', {
                taskId: response.jira.onIssueExported.task?.id
            });
        }
        if (response?.jira?.onIssueExported?.__typename === 'JiraIssueExportTaskTerminated') removeExportInProgress(exportItem.id);
    }, [
        createAnalyticsEvent,
        exportItem.id,
        removeExportInProgress
    ]);
    const handleOnErrorSubscription = (0, $5uXOq.useCallback)((exportIssuesSubscriptionError)=>{
        removeExportInProgress(exportItem.id);
        setError(exportIssuesSubscriptionError);
    }, [
        exportItem.id,
        removeExportInProgress
    ]);
    (0, $8Uumt.useSubscription)((0, $5uXOq.useMemo)(()=>({
            subscription: (0, $lKTmd.default),
            variables: {
                input: {
                    ...commonInput,
                    cloudId: cloudId,
                    maxResults: exportItem.maxResults,
                    exportType: exportItem.exportType
                }
            },
            onNext: handleOnNextSubscription,
            onError: handleOnErrorSubscription
        }), [
        cloudId,
        commonInput,
        exportItem.exportType,
        exportItem.maxResults,
        handleOnErrorSubscription,
        handleOnNextSubscription
    ]));
    if (error || exportIssuesTask?.__typename === 'JiraIssueExportTaskTerminated') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9cyMA.ExportIssuesTaskErrorFlag), {
        exportIssuesTask: exportIssuesTask,
        exportItem: exportItem,
        error: error,
        onDismissed: onDismissFlag
    });
    if (downloadCompleted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: "completed-flag",
        title: formatMessage((0, $5ylu6.default).exportIssuesFlagExportComplete),
        onDismissed: onDismissFlag,
        messageId: "issue-navigator-action-export-issues.ui.export-item.export-issues-task-flag.success-auto-dismiss-flag",
        messageType: "transactional"
    });
    if (exportIssuesTask?.__typename === 'JiraIssueExportTaskCompleted') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tbGZ.ExportIssuesTaskDownloadFlag), {
        exportIssuesTask: exportIssuesTask,
        exportItem: exportItem,
        onDismissed: onDismissFlag,
        onComplete: handleOnDownloadComplete
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a8IjR.ExportIssuesTaskProgressFlag), {
        exportIssuesTask: exportIssuesTask,
        exportItem: exportItem,
        onDismissed: onDismissFlag
    });
};

});
parcelRegister("lKTmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c336a0fb719f28fd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d194b2ad478534fb2954d5240b162d97>>
 * @relayHash adfe09a7742646fb90e2c99abadef611
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 90b09e75f08905e0f72ae32c810a0a8dfeecd094551eac2513d02943f5c485a9
const $c336a0fb719f28fd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "concreteType": "JiraIssueExportTask",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ]
    }, v4 = [
        v3 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "exportIssuesTaskFlagSubscription",
            "selections": [
                {
                    "concreteType": "JiraSubscription",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "onIssueExported",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "exportIssuesTaskProgressFlag_issueNavigatorActionExportIssues"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "exportIssuesTaskDownloadFlag_issueNavigatorActionExportIssues"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "exportIssuesTaskErrorFlag_issueNavigatorActionExportIssues"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v4 /*: any*/ ,
                                    "type": "JiraIssueExportTaskCompleted"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "exportIssuesTaskFlagSubscription",
            "selections": [
                {
                    "concreteType": "JiraSubscription",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "onIssueExported",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraIssueExportEvent"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "progress"
                                        }
                                    ],
                                    "type": "JiraIssueExportTaskProgress"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v4 /*: any*/ ,
                                    "type": "JiraIssueExportTaskSubmitted"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "downloadResultUrl"
                                        }
                                    ],
                                    "type": "JiraIssueExportTaskCompleted"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueExportTaskProgress",
                                            "kind": "LinkedField",
                                            "name": "taskProgress",
                                            "plural": false,
                                            "selections": v4 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraIssueExportError",
                                            "kind": "LinkedField",
                                            "name": "error",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayMessage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraIssueExportTaskTerminated"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "90b09e75f08905e0f72ae32c810a0a8dfeecd094551eac2513d02943f5c485a9",
            "metadata": {},
            "name": "exportIssuesTaskFlagSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$c336a0fb719f28fd$var$node.hash = "33e0edd502a7e443e2e99f8529ba470d";
var $c336a0fb719f28fd$export$2e2bcd8739ae039 = $c336a0fb719f28fd$var$node;

});

parcelRegister("8tbGZ", function(module, exports) {

$parcel$export(module.exports, "ExportIssuesTaskDownloadFlag", () => $ce4a4af2ccde0ed0$export$3c52361dded880e6);

var $eyPYx = parcelRequire("eyPYx");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $aousH = parcelRequire("aousH");

var $3Q6Z5 = parcelRequire("3Q6Z5");

var $6jQgn = parcelRequire("6jQgn");
const $ce4a4af2ccde0ed0$export$3c52361dded880e6 = ({ exportItem: exportItem, exportIssuesTask: exportIssuesTask, onComplete: onComplete, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [error, setError] = (0, $5uXOq.useState)();
    const exportIssuesTaskData = (0, $8Uumt.useFragment)((0, $eyPYx.default), exportIssuesTask);
    const handleOnError = (0, $5uXOq.useCallback)((downloadError)=>{
        setError(downloadError);
        (0, $jcw0u.default)({
            event: createAnalyticsEvent({}),
            // forces contextual attributes be included
            meta: {
                id: 'JiraIssueExportTaskDownloadFailed',
                packageName: (0, $44f1a30cb994896c$export$b8b9d90f9e5bd72b),
                teamName: (0, $44f1a30cb994896c$export$d57b6b390e78d90f)
            },
            error: downloadError,
            attributes: {
                taskId: exportIssuesTaskData.task?.id,
                errorCode: downloadError?.errorCode
            }
        });
    }, [
        createAnalyticsEvent,
        exportIssuesTaskData.task?.id
    ]);
    const handleOnDownloadDismissed = (0, $5uXOq.useCallback)(()=>{
        const cancelEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(cancelEvent, 'cancelDownloadJiraIssueExportTask', {
            taskId: exportIssuesTaskData?.task?.id
        });
        onDismissed();
    }, [
        createAnalyticsEvent,
        exportIssuesTaskData?.task?.id,
        onDismissed
    ]);
    const id = exportIssuesTaskData.task?.id || 'export-issues-download-flag';
    const downloadResultUrl = exportIssuesTaskData.downloadResultUrl || '';
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Q6Z5.ExportErrorFlag), {
        id: `export-issues-task-flag-download-error-${exportItem.id}`,
        errorTitle: formatMessage((0, $6jQgn.default).exportIssuesFlagDownloadErrorTitle),
        onDismissed: onDismissed
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aousH.DownloadFlag), {
        id: id,
        downloadUrl: downloadResultUrl,
        fileExtension: exportItem.fileExtension,
        onDismissed: handleOnDownloadDismissed,
        onComplete: onComplete,
        onError: handleOnError
    });
};

});
parcelRegister("eyPYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $75bcb77c0e013a28$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<df903e91c44c4d909eeea6be456c943f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $75bcb77c0e013a28$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "exportIssuesTaskDownloadFlag_issueNavigatorActionExportIssues",
    "selections": [
        {
            "concreteType": "JiraIssueExportTask",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "downloadResultUrl"
        }
    ],
    "type": "JiraIssueExportTaskCompleted"
};
$75bcb77c0e013a28$var$node.hash = "c7fbec2637efdd781e8042c4b9ed971d";
var $75bcb77c0e013a28$export$2e2bcd8739ae039 = $75bcb77c0e013a28$var$node;

});

const $44f1a30cb994896c$export$b8b9d90f9e5bd72b = 'jiraIssueNavigatorActionExportIssues';
const $44f1a30cb994896c$export$d57b6b390e78d90f = 'empanada';

parcelRegister("aousH", function(module, exports) {

$parcel$export(module.exports, "DownloadFlag", () => $6dd52ba1798dac8e$export$d4345bbed6befdb7);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");

var $32MQk = parcelRequire("32MQk");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $hdEGK = parcelRequire("hdEGK");

var $gwiPJ = parcelRequire("gwiPJ");
const $6dd52ba1798dac8e$export$d4345bbed6befdb7 = ({ id: id, downloadUrl: downloadUrl, fileExtension: fileExtension, onDismissed: onDismissed, onComplete: onComplete, onError: onError })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const abortController = (0, $5uXOq.useRef)(new AbortController());
    const handleOnDismissed = (0, $5uXOq.useCallback)(()=>{
        abortController.current.abort();
        onDismissed();
    }, [
        onDismissed
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const { signal: signal } = abortController.current;
        (0, $gwiPJ.downloadFile)({
            downloadUrl: downloadUrl,
            signal: signal
        }).then(()=>{
            onComplete();
        }).catch((error)=>{
            /**
       * We only want to propagate the error if it's not an abort error (triggered byt the user dismissing the flag)
       */ if (error.name !== 'AbortError') onError(error);
        });
    // We only want to trigger the download once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessFlag), {
        id: id,
        messageId: "issue-navigator-action-export-issues.common.ui.download-flag.success-flag",
        messageType: "transactional",
        title: formatMessage((0, $hdEGK.default).downloadingCsvFile, {
            fileExtension: fileExtension.toUpperCase()
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingInlineEnd: "space.400"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingBlockStart: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32MQk.default), {
            isIndeterminate: true,
            ariaLabel: formatMessage((0, $hdEGK.default).downloadingProgressBarAriaLabel)
        })))),
        onDismissed: handleOnDismissed
    });
};

});
parcelRegister("32MQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $baa3bacea9c957c9$export$2e2bcd8739ae039);
/* progress-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $baa3bacea9c957c9$var$MIN_VALUE = 0;
const $baa3bacea9c957c9$var$MAX_VALUE = 1;
const $baa3bacea9c957c9$var$increasingBarAnimation = null;
const $baa3bacea9c957c9$var$decreasingBarAnimation = null;
const $baa3bacea9c957c9$var$containerStyles = null;
const $baa3bacea9c957c9$var$containerAppearance = {
    default: "_bfhk1t45",
    success: "_bfhk1t45",
    inverse: "_bfhklgn7"
};
const $baa3bacea9c957c9$var$barAppearance = {
    default: "_bfhk1wby",
    success: "_bfhk1bh5",
    inverse: "_bfhkvuon"
};
const $baa3bacea9c957c9$var$barStyles = null;
const $baa3bacea9c957c9$var$determinateBarStyles = null;
const $baa3bacea9c957c9$var$increasingBarStyles = null;
const $baa3bacea9c957c9$var$decreasingBarStyles = null;
/**
 * __Progress bar__
 *
 * A progress bar displays the status of a given process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/code)
 * - [Usage](https://atlassian.design/components/progress-bar/usage)
 */ const $baa3bacea9c957c9$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $baa3bacea9c957c9$var$MIN_VALUE : Math.max($baa3bacea9c957c9$var$MIN_VALUE, Math.min(value, $baa3bacea9c957c9$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $baa3bacea9c957c9$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $baa3bacea9c957c9$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhk1t45",
            $baa3bacea9c957c9$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                        $baa3bacea9c957c9$var$barAppearance[appearance],
                        "_5sagymdr _tip812c5 _j7hq7g40"
                    ])
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                        $baa3bacea9c957c9$var$barAppearance[appearance],
                        "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $bwpsq.default)([
                "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                $baa3bacea9c957c9$var$barAppearance[appearance],
                "_v564calv"
            ])
        })
    });
};
var $baa3bacea9c957c9$export$2e2bcd8739ae039 = $baa3bacea9c957c9$var$ProgressBar;

});

parcelRegister("hdEGK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddf6f1ae8bad2840$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $ddf6f1ae8bad2840$var$messages = (0, $7VHMR.defineMessages)({
    downloadingCsvFile: {
        "id": "issue-navigator-action-export-issues.common.download-flag.downloading-csv-file",
        "defaultMessage": "Downloading {fileExtension} file"
    },
    downloadingProgressBarAriaLabel: {
        "id": "issue-navigator-action-export-issues.common.download-flag.downloading-progress-bar-aria-label",
        "defaultMessage": "Downloading in progress"
    }
});
var $ddf6f1ae8bad2840$export$2e2bcd8739ae039 = $ddf6f1ae8bad2840$var$messages;

});

parcelRegister("gwiPJ", function(module, exports) {

$parcel$export(module.exports, "downloadFile", () => $97b37a0899b34ea2$export$bb3b75778e3e272);

var $iwPwz = parcelRequire("iwPwz");

var $8CxS5 = parcelRequire("8CxS5");
const $97b37a0899b34ea2$export$bb3b75778e3e272 = async ({ downloadUrl: downloadUrl, signal: signal })=>{
    const response = await fetch(downloadUrl, {
        signal: signal
    });
    if (response.status === 200) {
        const filename = $97b37a0899b34ea2$var$getFilename(response);
        const blob = await response.blob();
        if (!false) {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    } else {
        const errorResponse = await response.json();
        const traceId = (0, $iwPwz.getTraceId)(response);
        const fetchError = new (0, $8CxS5.ExportIssuesDownloadError)({
            statusCode: response.status,
            message: errorResponse.message,
            traceId: traceId,
            errorCode: errorResponse.errorCode,
            response: response
        });
        throw fetchError;
    }
};
const $97b37a0899b34ea2$var$getFilename = (response)=>{
    const contentDisposition = response.headers.get('content-disposition');
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) return filenameMatch[1];
    }
    return 'Jira.csv';
};

});


parcelRegister("3Q6Z5", function(module, exports) {

$parcel$export(module.exports, "ExportErrorFlag", () => $57b434f3779dfe3e$export$28b2e84a6b6d8229);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $jA4iE = parcelRequire("jA4iE");
const $57b434f3779dfe3e$export$28b2e84a6b6d8229 = ({ id: id, errorTitle: errorTitle, errorMessage: errorMessage, onDismissed: onDismissed, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        id: id,
        title: errorTitle || formatMessage((0, $jA4iE.default).exportErrorFlagDefaultTitle),
        description: errorMessage || formatMessage((0, $jA4iE.default).exportErrorFlagDefaultDescription),
        onDismissed: onDismissed,
        messageId: "issue-navigator-action-export-issues.common.ui.export-error-flag.error-flag",
        messageType: "transactional",
        actions: actions
    });
};

});
parcelRegister("jA4iE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ab313e34ae3b3b3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $9ab313e34ae3b3b3$var$messages = (0, $7VHMR.defineMessages)({
    exportErrorFlagDefaultTitle: {
        "id": "issue-navigator-action-export-issues.common.export-error-flag.export-error-flag-default-title",
        "defaultMessage": "We couldn\u2019t export your issues"
    },
    exportErrorFlagDefaultDescription: {
        "id": "issue-navigator-action-export-issues.common.export-error-flag.export-error-flag-default-description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var $9ab313e34ae3b3b3$export$2e2bcd8739ae039 = $9ab313e34ae3b3b3$var$messages;

});


parcelRegister("6jQgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $55616ca0281cba83$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $55616ca0281cba83$var$messages = (0, $7VHMR.defineMessages)({
    exportIssuesFlagDownloadErrorTitle: {
        "id": "issue-navigator-action-export-issues.export-item.export-issues-task-flag.export-issues-task-download-flag.export-issues-flag-download-error-title",
        "defaultMessage": "We couldn't download your issues"
    }
});
var $55616ca0281cba83$export$2e2bcd8739ae039 = $55616ca0281cba83$var$messages;

});


parcelRegister("9cyMA", function(module, exports) {

$parcel$export(module.exports, "ExportIssuesTaskErrorFlag", () => $eaa01ace0885ccb2$export$ed7083d910edd3e2);

var $5vsAV = parcelRequire("5vsAV");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");


var $8mgvN = parcelRequire("8mgvN");

var $3Q6Z5 = parcelRequire("3Q6Z5");

var $etArH = parcelRequire("etArH");
const $eaa01ace0885ccb2$export$ed7083d910edd3e2 = ({ exportIssuesTask: exportIssuesTask, exportItem: exportItem, error: errorProp, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const exportIssuesTaskData = (0, $8Uumt.useFragment)((0, $5vsAV.default), exportIssuesTask);
    const statusCode = errorProp?.extensions?.statusCode || exportIssuesTaskData?.error?.statusCode;
    const errorType = errorProp?.extensions?.errorType || exportIssuesTaskData?.error?.errorType;
    let errorTitle;
    let errorMessage;
    let actions;
    (0, $5uXOq.useEffect)(()=>{
        (0, $jcw0u.default)({
            event: createAnalyticsEvent({}),
            // forces contextual attributes be included
            meta: {
                id: 'JiraIssueExportTaskExportFailed',
                packageName: (0, $44f1a30cb994896c$export$b8b9d90f9e5bd72b),
                teamName: (0, $44f1a30cb994896c$export$d57b6b390e78d90f)
            },
            sendToPrivacyUnsafeSplunk: true,
            error: errorProp || new Error(exportIssuesTaskData?.error?.displayMessage || undefined),
            attributes: {
                statusCodeGroup: (0, $etArH.getStatusCodeGroup)(statusCode),
                classification: errorProp?.extensions?.classification,
                errorSource: errorProp?.extensions?.errorSource,
                taskId: exportIssuesTaskData?.taskProgress?.task?.id,
                errorType: errorType,
                statusCode: statusCode,
                isSubscriptionFailure: Boolean(errorProp)
            }
        });
    // We only want to send error analytics on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $etArH.is4xxError)(statusCode)) switch(statusCode){
        case 429:
            errorTitle = formatMessage((0, $8mgvN.default).exportIssuesAlreadyInProgressTitle, {
                exportItemLabel: exportItem.label
            });
            errorMessage = formatMessage((0, $8mgvN.default).exportIssuesAlreadyInProgressDescription);
            actions = [
                {
                    content: formatMessage((0, $8mgvN.default).exportIssuesAlreadyInProgressCancelExportAction),
                    onClick: onDismissed
                }
            ];
            break;
        default:
            errorMessage = errorProp?.message || exportIssuesTaskData?.error?.displayMessage;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Q6Z5.ExportErrorFlag), {
        id: `export-issues-task-flag-error-${exportItem.id}`,
        errorTitle: errorTitle,
        errorMessage: errorMessage,
        onDismissed: onDismissed,
        actions: actions
    });
};

});
parcelRegister("5vsAV", function(module, exports) {

$parcel$export(module.exports, "default", () => $493d9a1943e69293$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e543e2a78e65cdf52b605f2a6ad897bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $493d9a1943e69293$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "exportIssuesTaskErrorFlag_issueNavigatorActionExportIssues",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssueExportTaskProgress",
                    "kind": "LinkedField",
                    "name": "taskProgress",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueExportTask",
                            "kind": "LinkedField",
                            "name": "task",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraIssueExportError",
                    "kind": "LinkedField",
                    "name": "error",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "displayMessage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "errorType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                }
            ],
            "type": "JiraIssueExportTaskTerminated"
        }
    ],
    "type": "JiraIssueExportEvent",
    "abstractKey": "__isJiraIssueExportEvent"
};
$493d9a1943e69293$var$node.hash = "187b120d7de34a9598bbe1dc5f854515";
var $493d9a1943e69293$export$2e2bcd8739ae039 = $493d9a1943e69293$var$node;

});


parcelRegister("a8IjR", function(module, exports) {

$parcel$export(module.exports, "ExportIssuesTaskProgressFlag", () => $107bc1f4244bf0ba$export$2a6a084811aadccf);

var $ctAxd = parcelRequire("ctAxd");

var $aarzp = parcelRequire("aarzp");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $koeKL = parcelRequire("koeKL");

var $jcw0u = parcelRequire("jcw0u");

var $eCBf9 = parcelRequire("eCBf9");

var $8mgvN = parcelRequire("8mgvN");

var $2oM72 = parcelRequire("2oM72");


var $etArH = parcelRequire("etArH");

var $9rRjZ = parcelRequire("9rRjZ");
/**
 * Only update progress if it is higher than the current progress, this prevents updating progress with a delayed backend event
 */ const $107bc1f4244bf0ba$var$useProgress = (progress)=>{
    const currentProgress = (0, $5uXOq.useRef)(0);
    if (progress > currentProgress.current) currentProgress.current = progress;
    return currentProgress.current;
};
const $107bc1f4244bf0ba$export$2a6a084811aadccf = ({ exportIssuesTask: exportIssuesTask, exportItem: exportItem, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const exportIssuesTaskData = (0, $8Uumt.useFragment)((0, $aarzp.default), exportIssuesTask);
    const [cancelExportIssueMutation] = (0, $4R6GH.fg)('jira_async_export_cancel_backend_job') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8Uumt.useMutation)((0, $ctAxd.default)) : [
        (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    ];
    const handleOnDismissed = (0, $5uXOq.useCallback)(()=>{
        onDismissed();
        const cancelEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(cancelEvent, 'cancelJiraIssueExportTask', {
            taskId: exportIssuesTaskData?.task?.id
        });
        if (exportIssuesTaskData?.task?.id && (0, $4R6GH.fg)('jira_async_export_cancel_backend_job')) cancelExportIssueMutation({
            variables: {
                cloudId: cloudId,
                taskId: exportIssuesTaskData?.task?.id
            },
            onCompleted: (data)=>{
                const { errors: errors } = data.jira?.requestCancelIssueExportTask || {};
                if (errors && errors.length > 0) {
                    const error = errors[0];
                    (0, $jcw0u.default)({
                        event: createAnalyticsEvent({}),
                        // forces contextual attributes be included
                        meta: {
                            id: 'cancelJiraIssueExportTaskExportFailed',
                            packageName: (0, $44f1a30cb994896c$export$b8b9d90f9e5bd72b),
                            teamName: (0, $44f1a30cb994896c$export$d57b6b390e78d90f)
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        error: new (0, $eCBf9.MutationError)(error),
                        attributes: {
                            taskId: exportIssuesTaskData?.task?.id,
                            statusCode: error.extensions?.statusCode,
                            errorType: error.extensions?.errorType,
                            statusCodeGroup: (0, $etArH.getStatusCodeGroup)(error.extensions?.statusCode)
                        }
                    });
                } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'cancelJiraIssueExportTask success', {
                    taskId: exportIssuesTaskData?.task?.id,
                    requestCancellationSuccess: data.jira?.requestCancelIssueExportTask?.success
                });
            },
            onError: (error)=>{
                (0, $jcw0u.default)({
                    event: createAnalyticsEvent({}),
                    // forces contextual attributes be included
                    meta: {
                        id: 'cancelJiraIssueExportTaskExportFailed',
                        packageName: (0, $44f1a30cb994896c$export$b8b9d90f9e5bd72b),
                        teamName: (0, $44f1a30cb994896c$export$d57b6b390e78d90f)
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    error: error,
                    attributes: {
                        taskId: exportIssuesTaskData?.task?.id
                    }
                });
            }
        });
    }, [
        cancelExportIssueMutation,
        cloudId,
        createAnalyticsEvent,
        exportIssuesTaskData?.task?.id,
        onDismissed
    ]);
    const id = exportIssuesTaskData?.task?.id || 'export-issues-task-progress-flag';
    const progress = (0, $4R6GH.fg)('jira_async_export_cancel_backend_job') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $107bc1f4244bf0ba$var$useProgress(exportIssuesTaskData?.progress || 0) : exportIssuesTaskData?.progress || 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2oM72.ProgressFlag), {
        onDismissed: handleOnDismissed,
        title: formatMessage((0, $9rRjZ.default).exportIssuesFlagProgressTitle, {
            exportItemLabel: exportItem.label
        }),
        description: formatMessage((0, $9rRjZ.default).exportIssuesFlagProgressDescription),
        progress: progress,
        progressAriaLabel: formatMessage((0, $9rRjZ.default).exportIssuesFlagProgressAriaLabel, {
            progress: progress * 100
        }),
        actions: [
            {
                content: formatMessage((0, $8mgvN.default).exportIssuesAlreadyInProgressCancelExportAction),
                onClick: handleOnDismissed
            }
        ],
        id: id
    });
};

});
parcelRegister("ctAxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1819f859d92f653c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8d572cecb80b38a9fc72aae62005cb75>>
 * @relayHash 77809d6b617cb5971d72835cf413b899
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5c92c4c8bf14e299d471c2633c7cedf9f05e82843c720c1c68cff61636c52f05
const $1819f859d92f653c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "taskId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "taskId",
            "variableName": "taskId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "exportIssuesTaskProgressFlagCancelMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueExportTaskCancellationResult",
                            "kind": "LinkedField",
                            "name": "requestCancelIssueExportTask",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "exportIssuesTaskProgressFlagCancelMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueExportTaskCancellationResult",
                            "kind": "LinkedField",
                            "name": "requestCancelIssueExportTask",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5c92c4c8bf14e299d471c2633c7cedf9f05e82843c720c1c68cff61636c52f05",
            "metadata": {},
            "name": "exportIssuesTaskProgressFlagCancelMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$1819f859d92f653c$var$node.hash = "9bf82f67ea927d86f56d964c945f60a3";
var $1819f859d92f653c$export$2e2bcd8739ae039 = $1819f859d92f653c$var$node;

});

parcelRegister("aarzp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0579f15a1c92b881$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<376d0e61c1cea2b46890dc60d34e63de>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0579f15a1c92b881$var$node = function() {
    var v0 = {
        "concreteType": "JiraIssueExportTask",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "exportIssuesTaskProgressFlag_issueNavigatorActionExportIssues",
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "progress"
                    }
                ],
                "type": "JiraIssueExportTaskProgress"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v0 /*: any*/ 
                ],
                "type": "JiraIssueExportTaskSubmitted"
            }
        ],
        "type": "JiraIssueExportEvent",
        "abstractKey": "__isJiraIssueExportEvent"
    };
}();
$0579f15a1c92b881$var$node.hash = "371625b39b4c37b1d9efbafcef54a1e3";
var $0579f15a1c92b881$export$2e2bcd8739ae039 = $0579f15a1c92b881$var$node;

});

parcelRegister("2oM72", function(module, exports) {

$parcel$export(module.exports, "ProgressFlag", () => $b647d890cfd769ac$export$92390c909b19c485);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");

var $32MQk = parcelRequire("32MQk");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $gcXWe = parcelRequire("gcXWe");
const $b647d890cfd769ac$export$92390c909b19c485 = ({ id: id, title: title, description: description, progress: progress, progressAriaLabel: progressAriaLabel, onDismissed: onDismissed, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.InfoFlag), {
        id: id,
        title: title,
        messageId: "issue-navigator-action-export-issues.common.ui.progress-flag.info-flag",
        messageType: "transactional",
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingInlineEnd: "space.400"
        }, description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingBlockStart: "space.100"
        }, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingBlockStart: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32MQk.default), {
            ariaLabel: progressAriaLabel,
            value: progress / 100
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingBlockStart: "space.100"
        }, formatMessage((0, $gcXWe.default).progressCompleted, {
            progress: progress
        }))),
        actions: actions,
        onDismissed: onDismissed
    });
};

});
parcelRegister("gcXWe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e0457b513f348f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $b3e0457b513f348f$var$messages = (0, $7VHMR.defineMessages)({
    progressCompleted: {
        "id": "issue-navigator-action-export-issues.common.progress-flag.progress-completed",
        "defaultMessage": "{progress}% completed"
    }
});
var $b3e0457b513f348f$export$2e2bcd8739ae039 = $b3e0457b513f348f$var$messages;

});


parcelRegister("9rRjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf4180a477b313b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $ebf4180a477b313b$var$messages = (0, $7VHMR.defineMessages)({
    exportIssuesFlagProgressTitle: {
        "id": "issue-navigator-action-export-issues.export-item.export-issues-task-flag.export-issues-task-progress-flag.export-issues-flag-progress-title",
        "defaultMessage": "{exportItemLabel} in progress"
    },
    exportIssuesFlagProgressDescription: {
        "id": "issue-navigator-action-export-issues.export-item.export-issues-task-flag.export-issues-task-progress-flag.export-issues-flag-progress-description",
        "defaultMessage": "Stay on this page until the export is complete. Leaving will cancel the export."
    },
    exportIssuesFlagProgressAriaLabel: {
        "id": "issue-navigator-action-export-issues.export-item.export-issues-task-flag.export-issues-task-progress-flag.export-issues-flag-progress-aria-label",
        "defaultMessage": "Export {progress}% completed"
    }
});
var $ebf4180a477b313b$export$2e2bcd8739ae039 = $ebf4180a477b313b$var$messages;

});


parcelRegister("5ylu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $435b7cfb3534c4a5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $435b7cfb3534c4a5$var$messages = (0, $7VHMR.defineMessages)({
    exportIssuesFlagExportComplete: {
        "id": "issue-navigator-action-export-issues.export-item.export-issues-task-flag.export-issues-flag-export-complete",
        "defaultMessage": "Export complete"
    }
});
var $435b7cfb3534c4a5$export$2e2bcd8739ae039 = $435b7cfb3534c4a5$var$messages;

});

parcelRegister("itJjG", function(module, exports) {

$parcel$export(module.exports, "getExportIssuesStatus", () => $252d98c85cee487d$export$8d3b7a7970e34e9);
/**
 * Export Issues Status used to track the status of the export in analytics
 */ const $252d98c85cee487d$var$ExportIssuesStatus = {
    // Export is initiated but no events have been received yet
    INITIATED: 'INITIATED',
    // Export is in progress
    EXPORTING: 'EXPORTING',
    // Export backend job is completed and download is in progress
    DOWNLOADING: 'DOWNLOADING',
    // Export download  is completed
    COMPLETED: 'COMPLETED',
    // Export has errored
    ERRORED: 'ERRORED'
};
const $252d98c85cee487d$export$8d3b7a7970e34e9 = ({ __typename: __typename, downloadCompleted: downloadCompleted, hasError: hasError })=>{
    if (downloadCompleted) return $252d98c85cee487d$var$ExportIssuesStatus.COMPLETED;
    if (__typename === 'JiraIssueExportTaskSubmitted' || __typename === 'JiraIssueExportTaskProgress') return $252d98c85cee487d$var$ExportIssuesStatus.EXPORTING;
    if (__typename === 'JiraIssueExportTaskCompleted') return $252d98c85cee487d$var$ExportIssuesStatus.DOWNLOADING;
    if (__typename === 'JiraIssueExportTaskTerminated' || hasError) return $252d98c85cee487d$var$ExportIssuesStatus.ERRORED;
    return $252d98c85cee487d$var$ExportIssuesStatus.INITIATED;
};

});



parcelRegister("2YYKT", function(module, exports) {

$parcel$export(module.exports, "getExportItems", () => $7e3c52641184bb8c$export$5765e17875154138);
$parcel$export(module.exports, "sortConnectAppsInExportItems", () => $7e3c52641184bb8c$export$856c5776b6ee557f);

const $7e3c52641184bb8c$var$getAllExportItems = (data)=>data && data.filter && data.filter.map((group)=>group.items);
const $7e3c52641184bb8c$export$5765e17875154138 = (data)=>$7e3c52641184bb8c$var$getAllExportItems(data);
const $7e3c52641184bb8c$export$856c5776b6ee557f = (exportItems, intlCollator)=>{
    const orderedExportItems = exportItems;
    orderedExportItems != null && orderedExportItems.length > (0, $dcaffc959cbdbdf4$export$726b5607b2c3e51c) && orderedExportItems[0, $dcaffc959cbdbdf4$export$726b5607b2c3e51c]?.sort((a, b)=>intlCollator.compare(a.label, b.label));
    return orderedExportItems;
};
const $7e3c52641184bb8c$var$receiveSameDomainOverride = (params)=>{
    const { s: command } = params;
    if (command !== 'hideLoading' && command !== 'showLoading') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.gadgets.rpc.originalReceiveSameDomain(params);
};
const $7e3c52641184bb8c$export$376579d4f72d02f1 = ()=>{
    // NOTE - In the past iframe gadgets in dashboards use rpc calls to talk to SPA but
    // we don't do it in NIN. A noop needs to be registered to showLoading and hideLoading
    // to overwrite the original that would throw an error. This is a temporary measure to
    // prevent Sentry noise - iframe gadgets will be deprecated in the near future.
    if (// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.gadgets?.rpc?.receiveSameDomain && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.gadgets.rpc.receiveSameDomain !== $7e3c52641184bb8c$var$receiveSameDomainOverride) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.gadgets.rpc.originalReceiveSameDomain = window.gadgets.rpc.receiveSameDomain;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.gadgets.rpc.receiveSameDomain = $7e3c52641184bb8c$var$receiveSameDomainOverride;
    }
};

});



//# sourceMappingURL=async-export-issues.226e0f9b.js.map
